//Deutsch  提示：只需要翻译冒号:后面的英文即可。
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage:{
     leanMore:'Mehr erfahren',
     skip:'Überspringen',
     activate:'aktivieren',
     emailSend: 'Email sent!',
     },
 leftBanner: {
    liteWebsite: 'Website-Backup',
    liteClone: 'Website-Klon',
    liteFile: 'Lite File',
    logoSlogan: 'The Go-To Choice for Cloud Transfer',
    cloudEscription: 'MultCloud – Die erste Wahl für die Datenübertragung von Cloud zu Cloud',
     commonTools: 'Gemeinsame Werkzeuge',
     cloudDrives: 'Mein Cloud-Laufwerk',
     onlineServices: 'Meine Online-Dienste',
     switchTxt: 'Klassisches MultCloud',
     taskList: 'Aufgabenliste',
     cloudTransfer: 'Cloud-Übertragung',
     cloudSync: 'Cloud-Synchronisation',
     cloudBackup:'Cloud Backup',
     btLink: 'Remote-Upload',
     teamTransfer:'Team-Übertragung',
     shares: 'Freigeben',
     emailTransfer: 'E-Mail-Migration',
     instagramDownload: 'Instagram Downloader',
     videoDownload: 'Video-Downloader',
     webDownload: 'Web Bild Downloader',
     addCloud: 'Clouds hinzufügen',
     addEmail: 'Clouds und E-Mails hinzufügen',
     manageClouds: 'Clouds & E-Mails verwalten',
     manageClouds2: 'Clouds verwalten',
     encryption: 'Verschlüsselung',
     edit: 'Wieder hinzufügen',
     remove: 'Entfernen',
     createTask: 'Aufgabe erstellen',
     createTaskText: 'Hier können Sie die häufigsten Aufgaben erstellen.',
     gotIt: 'Verstanden',
     bigWriteEncrypt: 'Verschlüsselung',
     encryptionText: 'Hier können Sie die Verschlüsselung von Cloud-Dateien einrichten.',
     addCloudText: 'Klicken Sie hier, um Ihr Cloud-Laufwerk und Ihre E-Mail mit MultCloud zu verbinden.',
     inviteFriends: 'Freunde einladen',
     switchTip:'Zur klassischen MultCloud wechseln',
     switchTipDes:'Hier können Sie zur klassischen MultCloud wechseln.',
     new: 'Neu',
 },
 common: {
     dropFilesToUpload: 'Dateien hier ablegen, um sie in den aktuellen Ordner hochzuladen',
     uploadUnavailable: 'Dateien können im aktuellen Zustand hier nicht hochgeladen werden',
     listView: 'Listenansicht',
     gridView: 'Rasteransicht',
     sortBy: 'Sortieren nach',
     ascending: 'Aufsteigend',
     descending: 'Absteigend',
     addCloud: 'Cloud hinzufügen',
     addEmail: 'E-Mail hinzufügen',
    options: 'Optionen',
     schedule: 'Zeitplan',
     ok: 'OK',
     save: 'Speichern',
     add: 'Hinzufügen',
     upgradeNow: 'Jetzt aktualisieren',
     addWebsite: 'Website hinzufügen',
     websiteName: 'Website-Name',
     websiteTip: 'Klicken Sie hier, um die Website hinzuzufügen, die Sie sichern möchten.',
     continue: 'Fortfahren',
     overwriteTip: 'Wenn die Ziel-Website-Dateien oder -Datenbanken bereits existieren, werden sie durch diese Wiederherstellung überschrieben. Möchten Sie fortfahren?',
     overwriteTip2: 'Wenn die Ziel-Website-Dateien oder -Datenbanken bereits existieren, werden sie durch diesen Klonvorgang überschrieben. Möchten Sie fortfahren?',
     from: 'Von',
     to: 'Nach',
     result: 'Ergebnis',
     fileProcess: 'Verarbeitete Dateien',
     transferFiles:'Dateien',
     dataProcess: 'Verarbeitete Daten',
     startTime: 'Startzeit',
     currentRate: 'Tageskurs',
     endTime: 'Endzeit',
     timeRemaining: 'Verbleibende Zeit',
     averageRate: 'Durchschnittsrate',
     averageRateSpecial: 'Avg.Rate',
     viewFailed: 'Klicken um fehlgeschlagene Dateien anzuzeigen',
     fileSuccess: 'Alle Dateien erfolgreich übertragen',
     size: 'Größe',
     path: 'Pfad',
     setUp: 'Einrichten',
     backups: 'Backups',
     restoreTo: 'Wiederherstellen nach',
     restoreNewLocation: 'Wiederherstellung an neuen Speicherort',
     executedTimes: 'Ausgeführte Zeit',
     sourceDir: 'Quellverzeichnis',
     cause: 'Ursache',
     retry: 'Wiederholen',
     retryMin: 'Wiederholen',
     clean: 'Bereinigen',
     properties: 'Eigenschaften',
     copy: 'Kopieren',
     move: 'Verschieben',
     multiSelect: 'Mehrfachauswahl',
     close: 'Schließen',
     copyTo: 'Kopieren auf',
     tranTo: 'Übertragen nach',
     syncWith: 'Synchronisieren mit',
     backupTo: 'Sichern nach',
     download: 'Herunterladen',
     delete: 'Löschen',
     more: 'Mehr',
     preview: 'Vorschau',
     share: 'Freigeben',
     shareWith: 'Mit MultCloud freigeben',
     shareTransfer: 'Eine Übertragung erstellen',
     encrypt: 'Verschlüsseln',
     encryptFile: 'Nur Datei verschlüsseln',
     encryptFileName: 'Datei und Name verschlüsseln',
     decrypt: 'Entschlüsseln',
     decryptFile: 'Nur Datei entschlüsseln',
     decryptFileName: 'Datei und Name entschlüsseln',
     onedriveBusinessContentNote: 'Hinweis',
     oneDrive4BusinessContent: 'Wenn Sie ein Administrator sind und einem Benutzer eine Microsoft 365-Lizenz zugewiesen haben, aber beim Versuch, über MultCloud auf den Ordner des Benutzers zuzugreifen, die Fehlermeldung „Zugriff verweigert“ erhalten, versuchen Sie bitte die folgenden Schritte:',
     oneDrive4BusinessTips1: `Gehen Sie zu „<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Admin</a>“. Wählen Sie die Registerkarte „Benutzer“ > Aktive Benutzer >“ Wählen Sie die Option „Produktlizenz verwalten“.`,
     oneDrive4BusinessTips2: 'Gehen Sie zur Registerkarte „OneDrive“ und klicken Sie auf „Link zur Datei erstellen“. Gehen Sie dann zurück zu MultCloud und versuchen Sie erneut, auf das Konto zuzugreifen.',
     oneDrive4BusinessStep1: 'Schritt 1',
     oneDrive4BusinessStep2: 'Schritt 2',
     upStep: 'Zurück',
     nextStep: 'Weiter',
     complete: 'Fertig',
     cut: 'Schneiden',
     viewDetails: 'Details anzeigen',
     toOfficialSite: 'Offizielle Seite',
     btLinkTask: 'Remote-Aufgabe',
     fileName: 'Dateiname',
     itemsSelected: 'Elemente ausgewählt',
     dateModified: 'Änderungsdatum',
     rename: 'Umbenennen',
     paste: 'Einfügen',
     btLink: 'Remote-Upload',
     load: 'Laden',
     status: 'Status',
     operate: 'Bedienen',
     failure: 'Fehler',
     link: 'Link',
     cleanList: 'List leeren',
     type: 'Typ',
     account: 'Konto',
     name: 'Name',
     selectFailedFile: 'Wählen Sie bitte fehlgeschlagene Datei aus',
     transferring: 'Übertragen',
     newPassword: 'Neues Passwort',
     confirmPassword: 'Passwort bestätigen',
     done: 'Fertig',
     no: 'Nein',
     yes: 'Ja',
     attention: 'Achtung',
     cancel: 'Abbrechen',
     unsubscribe: 'Abbestellen',
     reactivate: 'Reaktivieren Sie es',
     sureCleanAll: 'Sind Sie sicher, alle erledigten Aufgaben zu löschen?',
     failedFiles: 'Fehlgeschlagene Dateien',
     minTo: 'zu',
     retryAll: 'Alle wiederholen',
     viewProgress: 'Prozess anzeigen',
     taskNotRun: 'Diese Aufgabe läuft nicht.',
     success: 'Erfolg',
     failure: 'Fehler',
     canceled: 'Abgebrochen',
     patial: 'Teilerfolg',
     syncDetails: 'Details synchronisieren',
     width: 'Breite',
     sync: 'Sync',
     targetCloud: 'Ziel-Clouds',
     running: 'Laufen',
     preparing: 'Vorbereiten',
     waiting: 'warten',
     target: 'Ziel',
     noVip: 'Sie haben jetzt maximal 2 Dateien gleichzeitig übertragen. Führen Sie ein Upgrade auf jeden Premium-Service aus, um maximal 10 zu haben!',
     vipThanks: 'Vielen Dank für das Abonnieren unseres Dienstes. Sie können jetzt maximal 10 Dateien gleichzeitig übertragen.',
     emailAccount: 'Email-Konto',
     with: 'Mit',
     syncing: 'Synchronisieren',
     selectAll: 'Alles auswählen',
     date: 'Datum',
     failed: 'Fehlgeschlagen',
     skip: 'Überspringen',
     replace: 'Ersetzen',
     ready: 'Bereit',
     connecting: 'Anschließen',
     account: 'Konto',
     selectNull: 'Bitte wählen Sie ein Zielverzeichnis.',
     selectOther: 'Dieses Verzeichnis kann nicht zum Einfügen von Dateien ausgewählt werden. Sie können seine Unterverzeichnisse oder andere Verzeichnisse auswählen.',
     //2020-10-26-ljm新增
     filterHolder:'Gib hier eine Dateierweiterung ein, z.B. mp4.',
     countFiles:'Dateien zählen',
     //2020-8-18-xth新增
     editShare: 'Freigabe bearbeiten',
     toSource: 'Zur Quelle',
     copyLink: 'Link kopieren',
     toShare: 'Teilen',
     report: 'Bericht',
     expand: 'Erweitern',
     shrink: 'Schrumpfen',
       //2020-12-2-ljm新增
     upgradeMulti:'Upgrade auf Multithreading',
     team: "Team-Datei",
     loadData:'Daten werden geladen, bitte warten',
     getAccountInfo:'Die Kontoinformationen können nicht erhalten werden. Bitte melden Sie sich erneut an und versuchen Sie es erneut.',
     loadingData:'Daten laden ...',
     failedEmptyTip: 'Die Dateien konnten nicht geladen werden. Bitte kontaktieren Sie <a href="mailto:support@multcloud.com">support@multcloud.com</a> für weitere Hilfe.',
     runNow:'Jetzt ausführen',
     emailFilter: 'E-Mail-Filter',
     me: "Ich",
     reset: "Zurücksetzen",
     apply: "Anwenden",
     failureReason: 'Fehlerursache',
     countingFilesTip: 'Wird berechnet ({num} Dateien)',
     taskName: 'Aufgabenname',
     frequency: 'Frequenz:',
     canceling: 'Abbrechen ...',
 },
 rightTopBanner: {
    navTransfer: 'Cloud-zu-Cloud-Übertragung',
    navInstagram: 'Instagram Downloader',
    navVideo: 'Video-Downloader',
    navWeb: 'Web Bild Downloader',
    traffic: 'Bandbreite',
    upgrade: 'Aktualisieren',
    settings: 'Einstellungen',
    changePassword: 'Passwort ändern',
    changeName: 'Name ändern',
    bindEmail: 'E-Mail binden',
    deleteAccount: 'Konto entfernen',
    language: 'Sprache',
    help: 'Hilfe',
    notifications: 'Benachrichtigungen',
    notification: 'Aktualisierungen',
    subAccounts: 'Unterkonten',
    logout: 'Ausloggen',
    tutorials: 'Tutorials',
    contact: 'Kontakt',
    limitsClouds: 'Einschränkungen von Clouds',
    faq: 'FAQ',
    purTraffic: 'Datenvolumen kaufen',
    unlimitedPlan: 'Unbegrenzter Plan',
    monthlyUnlimitedPlan: 'Monatlich Unbegrenzter Plan',
    rememberOriginal: 'Bitte merken Sie sich Ihren ursprünglichen Benutzernamen:',
    andPassword: 'und Passwort',
    bindEmailOpen: 'Am besten <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">binden Sie Ihre E-Mail-Adresse und ändern Sie das Standardkennwort</span> für die Sicherheit und Bequemlichkeit.',
    lifeSwitchTip: 'Mit dem LEBENSLANGEN UNBEGRENZTEN-Dienst können Sie Dateien ohne Datenvolumen-Grenzen zwischen Clouds übertragen.',
    lifeTimePlan: 'Lebensdauer unbegrenzt',
    browserPrompt:'Für eine bessere Nutzererfahrung empfehlen wir, Google Chrome zu verwenden.',
    unlimited:'Unbegrenzt',
    lifeTimeNotice:'Sie sind ein Benutzer für MultCloud Lebenslang Unbegrenzten Plan.',
    subAccount:"Unterkonto",
    bindMailTips:"Bitte binden Sie Ihre E-Mail ein, um die Übertragung von Dateien in der Cloud freizuschalten und das Beste aus MultCloud zu machen.",
     bind:"Binden",
 },
 liteApp: {
     menu: 'Meine Apps',
     title: 'Meine Apps',
     edit: 'Bearbeiten',
     warning: 'Warnung',
     description: 'Verwalten Sie OAuth-Anwendungen zum Verbinden von Cloud-Diensten.',
     addApp: 'App hinzufügen',
     empty: 'Sie haben noch keine benutzerdefinierten Apps hinzugefügt.',
     appType: 'Cloud-Dienst',
     appName: 'App-Name',
     clientId: 'Client-ID / App-Key',
     clientSecret: 'Client-Secret / App-Secret',
     callback: 'Umleitungs-URI',
     secretUnchanged: 'Leer lassen, um den Wert beizubehalten',
     inUse: 'In Verwendung',
     usedTip: 'Diese App wird von mindestens einem Cloud-Laufwerk verwendet. Ihre Zugangsdaten können nicht geändert werden.',
     nameRequired: 'Bitte geben Sie einen App-Namen ein.',
     credentialsRequired: 'Bitte geben Sie Client-ID und Client-Secret ein.',
     secretRequiredForKey: 'Geben Sie beim Ändern der Client-ID das Client-Secret ein.',
     deleteConfirm: 'Diese benutzerdefinierte App löschen? Cloud-Laufwerke, die sie verwenden, müssen zuerst entfernt werden.',
     appInUse: 'Diese App wird von einem Cloud-Laufwerk verwendet und kann nicht gelöscht oder in ihren Zugangsdaten geändert werden.',
     nameExists: 'Für diesen Cloud-Dienst gibt es bereits eine App mit diesem Namen.',
     systemAppUnavailable: 'Die MultCloud-Standard-App ist für diesen Cloud-Dienst nicht verfügbar.',
     selectApp: 'App',
     defaultApp: 'MultCloud-Standard-App verwenden',
     selectAppTip: 'Wählen Sie die App zur Autorisierung dieses Cloud-Dienstes.',
     copySuccess: 'In die Zwischenablage kopiert',
 },
 popup: {
    userStarPopup: {
        starDesc: "Wie sind Ihre bisherigen Erfahrungen?",
        ok: "OK",
        thankYou: "Vielen Dank！",
        thankYouDesc: "Wenn Sie uns Ihre echten und ehrlichen Erfahrungen mit unserem Produkt mitteilen, würde dies unserem kleinen Team helfen, MultCloud noch besser zu machen.",
        reviewStart: "Bewerten Sie uns auf",
        reviewEnd: "",
        feedbackTitle: "Wie können wir besser werden?",
        feedbackDesc: "Geben Sie Ihr Feedback",
        feedbackBtn: "Einreichen",
        feedbackYes: "Danke für die Rückmeldung.",
        feedbackNo: "Bitte geben Sie Ihr Feedback ein.",
    },
     addCloudPopup: {
         endpointOptional:' Endpunkt (optional)',
         regionOptional: 'Region (optional)',
         bucketOptional: 'Bucket (optional)',
         //2020.09.23 添加NAS云盘
         addNas: 'NAS HINZUFÜGEN',
         addNasFtpDes: `Verbinden Sie NAS über FTP. Wissen Sie nicht, wie FTP für NAS einzurichten? Bitte klicken Sie <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>hier</a>`,
         addNasWebDes: `Verbinden Sie NAS über WebDAV. Wissen Sie nicht, wie WebDAV für NAS einzurichten? Bitte klicken Sie  <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>hier</a>`,
         bucketName: 'Bucket-Name',
         accessKeyId: 'Zugangsschlüssel-ID',
         idriveSecretAccessKey: 'Secret Access Key',
         endpoint: 'Endpoint',
         idriveKeyId: 'Access Key ID',
         secretAccessKey: 'Geheimer Zugangsschlüssel',
         displayName: 'Anzeigename',
         addFtp: 'FTP HINZUFÜGEN',
         addFtpDes: 'Um Ihr FTP zu verbinden, müssen Sie in MultCloud Ihre Authentifizierungsdetails eingeben.',
         egnyteTip: `Tipps: Um Ihr key und secret zu erhalten, benötigen Sie Egnyte API-Verwaltungs-ID. Wenn Sie noch keins haben, können Sie sich <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>hier registrieren</a>.`,
         icedriveTip2:`2. Klicken Sie auf Ihren Icedrive-Benutzernamen -> 2FA & Zugriff -> WebDAV -> Aktivieren -> Schlüssel anzeigen. Der Zugriffsschlüssel ist das Passwort.`,
         icedriveTip: 'Hinweis:',
         icedriveTip1:'1. Unterstützt nur Icedrive Premium-Konten.',
         iCloudPhotosTip: 'Tipps:',
         iCloudPhotosTip1: '1. Bevor Sie Ihre iCloud-Fotos mit MultCloud verbinden, stellen Sie bitte sicher, dass „Zugriff auf iCloud-Daten im Web“ aktiviert ist.',
         iCloudPhotosTip1Q: `Wie verwalte ich den Webzugriff auf Ihre iCloud-Daten:<br><br>Auf iPhone oder iPad<br>1. Öffnen Sie die Einstellungen-App.<br>2. Tippen Sie auf Ihren Namen und dann auf iCloud.<br><br>3. Tippen Sie auf, um den Zugriff auf iCloud-Daten im Web zu deaktivieren oder zu aktivieren.<br>
        <br>Auf Mac<br>1. Wählen Sie Apple-Menü > Systemeinstellungen.<br>2. Klicken Sie auf Ihren Namen und dann auf iCloud.<br>3. Klicken Sie, um den Zugriff auf iCloud-Daten im Web zu deaktivieren oder zu aktivieren.`,
         iCloudPhotosTip2: '2.iCloud Fotos unterstützt nur die folgenden Bildformate: jfif, pjpeg, jpeg, pjp, jpg, heic.',
         iCloudDomainTip: 'Wenn Ihr iCloud-Konto zur Region China gehört, stellen Sie bitte sicher, dass Sie im Feld Domain www.icloud.com.cn auswählen.',
         googleDrive2FATip: 'Tipps für die 2-Faktor-Authentifizierung von Google Drive',
         googleDrive2FATip1: 'Bitte stellen Sie sicher, dass Sie auf der Google Drive-Autorisierungsseite „Alle Ihre Google Drive-Dateien anzeigen, bearbeiten, erstellen und löschen“ aktivieren.',
         server: 'Server',
         protocol: 'Protokoll',
         port: 'Port',
         passive: 'Passiver Modus',
         passphrase: 'Passphrase',
         explanation: 'Um eine Verbindung zu FTP herzustellen, sollte das Präfix "ftp://" sein, oder das Präfix wird verpasst.Wenn Ihr FTP-Port nicht standardmäßig ist, wird eine spezielle Portnummer verwendet, z.B. 21.Verwenden Sie bitte das Format, um den folgenden Port anzugeben: ftp://ftp.myhost.com:21',
         userName: 'Benutzername',
         passWord: 'Passwort',
         advanced: 'Erweitert',
         commFTP: 'Gängiges FTP',
         transMode: 'übertragungsmodus',
         encoding: 'Kodierung',
         path: 'Pfad(optional)',
         cloudName: 'Cloud Name',
         cloudService: 'Cloud-Dienst',
         addedTime: 'Hinzugefügte Zeit',
         userName: 'Benutzername',
         usedSpace: 'Belegter Speicherplatz',
         totalSpace: 'Gesamtspeicherplatz',
         iCloudUsedSpace: 'iCloud Fotos Speicher',
         iCloudDriveUsedSpace: 'iCloud Drive Speicher',
         iCloudTotalSpace: 'iCloud Gesamtspeicher',
         iCloudDriveTotalSpace: 'iCloud Gesamtspeicher',
         removeContent: 'Einige Cloud-Übertragungsaufgaben basieren auf dieser Cloud. Möchten Sie sie noch entfernen?',
         google_driveTips: 'Wenn Sie Dateien oder Ordner von Google Drive auf andere übertragen, stellen Sie bitte sicher, dass sich nicht dieselben Dateinamen im gleichen Verzeichnis befinden.',
         baiDuTips: 'Sie können nur Dateien in das Verzeichnis „全部文件/我的应用数据/MultCloud” hochladen oder übertragen.',
         mySQLQuestion: 'Sie müssen Ihre IP-Adresse des MySQL Servers in das Serverfeld eingeben, und der Standardport ist 3306, oder Sie sollten Ihren benutzerdefinierten Port eingeben.',

         webDavQuestion: `Wenn Sie eine sichere SSL-Verbindung verwenden, fügen Sie hinzu "https://", ein Präfix hinzu oder tun Sie nichts, und der Standardport ist 443, andernfalls sollte das Präfix "http://" sein und der Standardport ist 80.
             e.g. https://dav.box.com/dav`,

         egnyteQuestion: 'Melden Sie sich bei Engnyte an und finden Sie Ihre Domain in der Adressleiste. Bitte geben Sie die Domain in diesem Format ein: e.g. https://aomeitech.egnyte.com/',

         ownCloudQuestion: 'Wenn Sie eine sichere SSL-Verbindung verwenden, fügen Sie hinzu "https://" ein Präfix hinzu oder tun Sie nichts, und der Standardport ist 443, andernfalls sollte das Präfix "http://" sein und der Standardport ist 80',

         amazonQuestion: `Besuchen Sie die Seite, um zu erfahren <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>wie Sie die Amazon S3-Zugriffsschlüssel-ID erhalten</a>`,

         boxTips: `Box unterstützt die Übertragung einer einzelnen Datei mit mehr als 2 GB nicht.`,
         google_drive_sharedWithMeTips:'Wenn Sie Sie Dateien in Ordner auf Shared With Me Drive übertragen, vergewissern Sie sich bitte, dass Sie über die „Erlaubnis zum Hochladen”verfügen.',
         gSuiteSharedDriveTips:'Wenn Sie Sie Dateien in Ordner auf Shared Drive übertragen, vergewissern Sie sich bitte, dass Sie über die „Erlaubnis zum Hochladen”verfügen.',
         webDavTips: `1.Stellen Sie sicher, dass Sie vor dem Dateivorgang über Lese-/Schreibberechtigungen verfügen. Andernfalls kann MultCloud möglicherweise keine Dateien in Ihren WebDav übertragen.
             2. Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         aDriveTips: 'Wir unterstützen Personal Premium- und Geschäftskonten, derzeit jedoch kein Persönliches Basiskonto.',
         yandexTips: `1.Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.
                      2.Wenn Sie das App-Passwort aktiviert haben, geben Sie das App-Passwort in der Passwortleiste oben ein.`,
         googlePhotosTips: `1.Das Verzeichnis "Photos" kann nur Bilder, Videos und andere Mediendateien speichern, nicht jedoch Verzeichnisse.
             2.Das Verzeichnis "Albums" kann nur Albumverzeichnisse speichern, keine Mediendateien.
             3.Das Verzeichnis "Sharing" enthält alle von Ihnen freigegebenen Alben oder die freigegebenen Alben, denen Sie beigetreten sind.
             4.Google Fotos unterstützt nur das Hochladen von Bildern, Videos und anderen Mediendateien. Wenn Sie die MultCloud "Hochladen" Funktion verwenden, können Sie nur Dateien in die von MultCloud erstellten oder freigegebenen Albumverzeichnisse hochladen.
             5.Wenn Sie die Quellfreigabe-Funktion von MultCloud verwenden, können Sie nur die von MultCloud erstellten Alben freigeben.
             6.Alle Alben ohne Titel werden als "Ohne Titel" angezeigt.
             7.Derzeit ist die "Herunterladen" Funktion verfügbar, das Herunterladen von Originaldateien wird jedoch nicht unterstützt.
             8.Derzeit werden Funktionen zum Ausschneiden, Löschen und Umbenennen nicht unterstützt. Und Sie können die Funktionen, die auf diesen Operationen beruhen, nicht verwenden.`,
         googlePhotosV2Tips: `1.Das Verzeichnis "Photos" kann nur Bilder, Videos und andere Mediendateien speichern, nicht jedoch Verzeichnisse.
             2.Das Verzeichnis "Albums" kann nur Albumverzeichnisse speichern, keine Mediendateien.`,

         evernoteTips: `1. API-Ratenbeschränkungen <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Details anzeigen>> </a>
               2. Was sind die Systemgrenzen von Evernote? <a href='https://help.evernote.com/hc/de/articles/209005247-Systemlimits-von-Evernote' target="_blank" class='add-cloud-link'>Details anzeigen>></a>
               3. Sie können nur eine Datei mit weniger als 50 MB in die Notiz hochladen.
               4. Die Notizeninhaltsdateien können nicht umbenannt oder gelöscht werden (. ENML).
               5. Kann die Notizen nur in der Notizbücher kopieren.`,

         flickrTips: `1. Sie können nur Bilder oder Videos auf Flickr übertragen.
             2. Ordner können nur in das Verzeichnis "Alben" übertragen werden und es dürfen keine Unterverzeichnisse im Verzeichnis "Alben" vorhanden sein.
             3. Dateien können nur in das von Ihnen erstellte Verzeichnis "Ihr  Fotostream" oder "Alben" übertragen werden.
             4. Alle Ihre Dateien finden Sie im Verzeichnis "Ihr Fotostream".
             5. Alle Dateien im Verzeichnis "Alben" verweisen auf das Verzeichnis "Ihr Fotostream".`,

         mediafireTips: 'MediaFire unterstützt nicht die leere Datei hochladen und herunterladen. Das Öffnen eines Ordners mit vielen Dateien kann lange dauern.',

         mySQLTips: `1. Auf Ihre Datenbank muss über unsere IP-Adressen zugegriffen werden können, die 209,126% betragen. Sie können einen neuen Benutzer über Ihre Datenbank- oder Host-Schnittstelle erstellen. Der MySQL-Befehl lautet wie folgt:
             <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIZIERT DURCH 'Passwort';</span>
             2. Ihr Server muss möglicherweise eine Firewall-Regel mit unseren IP-Adressen und dem Zugriff auf den Port hinzufügen(Der Standardport ist 3306), um normal auf Ihre Datenbanken zuzugreifen.`,
         hubiCTips: `1. Ein HubiC-Konto kann nur einmal hinzugefügt werden.
             2. Sie können Dateien oder Ordner nicht umbenennen und ausschneiden.
             3. Das Löschen von Ordnern mit vielen Dateien kann etwas langsam sein.
             4. HubiC unterstützt nicht die Übertragung einzelner Dateien, die größer als 5 GB sind.
             5. Dateinamen dürfen nicht länger als 248 Zeichen sein und Ordnernamen sind auf 256 Zeichen begrenzt.`,

         gSuiteUpTips: `Die Verbindung zwischen G Suite und MultCloud ist nur für G Suite-Administratoren verfügbar. Um G Suite mit MultCloud zu verbinden, müssen Sie unsere G Suite Marketplace App --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> zuerst "DOMAIN INSTALLIEREN".`,

         gSuiteTips: `1.Sie müssen ein <a href="https://support.google.com/a/answer/2405986?hl=de" target="_blank" class='add-cloud-link'> G Suite-Administrator</a>.
                         2.So überprüfen Sie, ob es sich um ein Administratorkonto handelt. Verweisen Sie zunächst auf diesen Link <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. Zweitens melden Sie sich über den Link in Ihrem Gsuite-Konto an. Drittens finden Sie die Ergebnisse in der Zeile "Benutzerdefinierte Administratorrollen erstellen".
                         3.Der <a href='https://support.google.com/a/answer/60757?hl=de' target="_blank" class='add-cloud-link'>API-Zugriff </a> ist aktiviert.
                         4.Bevor Sie dieses Cloud-Laufwerk hinzufügen, sollten Sie zuerst unsere <a href='https://gsuite.google.com/marketplace?hl=de' target="_blank" class='add-cloud-link'> G Suite Marketplace App </a> "MultCloud for G Suite" und sicherstellen, dass  die  <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> Einrichtung </a> korrekt ist: Der Status ist aktiviert und der Datenzugriff wird gewährt.`,

         hiDriveTips: `1.Bitte vergewissern Sie sich, dass Sie ein Konto mit aktiviertem WebDAV-Protokoll und Lese-/Schreibrechten haben, bevor Sie mit Dateien arbeiten, da MultCloud sonst möglicherweise keine Dateien auf Ihr HiDrive übertragen kann.
             2. Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         backblazeTips: `1.Jeder Bucket-Name muss mindestens 6 Zeichen lang sein.
             2.Wenn Sie einen neuen Anwendungsschlüssel erstellen, funktioniert der alte nicht mehr.
             3.Dateinamen dürfen mit  "/" beginnen, mit "/" enden , oder "//" enthalten nicht.`,
         WEBDETips: `1.Stellen Sie sicher, dass Sie vor dem Dateivorgang über Lese-/Schreibberechtigungen verfügen. Andernfalls kann MultCloud möglicherweise keine Dateien in Ihren Web.De übertragen.
             2. Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         alfrescoTips: `Als kostenloses Alfresco-Konto beträgt Ihr Speicherplatz für das Netzwerk 10 GB und die maximale Dateigröße beträgt 50 MB.`,
         cloudMeTips: `1.Stellen Sie sicher, dass Sie vor dem Dateivorgang über Lese-/Schreibberechtigungen verfügen. Andernfalls kann MultCloud möglicherweise keine Dateien in Ihren CloudMe übertragen.
             2. Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         myDriveTips: `Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         cubbyTips: `1.Stellen Sie sicher, dass Sie vor dem Dateivorgang über Lese-/Schreibberechtigungen verfügen. Andernfalls kann MultCloud möglicherweise keine Dateien in Ihren Cubby übertragen.
             2. Bitte stellen Sie sicher, dass genügend Platz für Ihre Operationen vorhanden ist. Wir können seine Größe vorübergehend nicht bestimmen.`,
         cloudType: 'Cloud-Typen',

         notificationTip: `Vielen Dank für die Verwendung der neuesten MultCloud. Wenn Sie Probleme haben, senden Sie ein Feedback an:<a href="mailto:support@multcloud.com">support@multcloud.com</a>, Vielen Dank.`,

         notAbleAccess: 'Kein Zugriff auf Google Fotos Problem wird gelöst',

         problemNotAccess: 'Das Problem, dass Sie nicht auf Google Fotos zugreifen können, wurde gelöst. Wenn Sie immer noch nicht auf Google Fotos zugreifen können, fügen Sie es erneut zu MultCloud hinzu.',

         noPrompt: 'Keine Aufforderung wieder',
         addFeatures: 'Hier sind einige neue Funktionen:',
         version: 'Version:',
         releasedOn: 'Veröffentlicht am ',
         newLabel: 'Neu :',
         improvedLabel: 'Verbessert :',
         noteLabel: 'Hinweis :',
         tryNewFeatures: 'Probieren Sie diese neuen Funktionen jetzt aus und verbessern Sie Ihre Dateiverwaltungserfahrung mit MultCloud!',
         okButton: 'OK',
        notif_v885: `Website-Backup: Sichern Sie Website-Dateien oder Datenbanken einfach in der Cloud und stellen Sie sie bei Bedarf wieder her. Website-Klon: Kopieren Sie Website-Dateien oder Datenbanken einfach auf eine andere Website.`,
        notif_v884: `Die Höhe der Cloud-Liste wurde erhöht, damit mehrere Cloud-Konten leichter angezeigt und verwaltet werden können.`,
        notif_v881: `iCloud-Autorisierung verbessert: Gerätebestätigungscodes werden unterstützt; MultCloud-Plus-Funktionen wurden optimiert und die schnelle Facebook-Anmeldung wiederhergestellt.`,
        notif_v880: `MultCloud Plus eingeführt: Unterstützt derzeit Cloud-Übertragungen und ausgewählte Cloud-Dienste für eine leichtere Nutzung und höhere Erfolgsrate.`,
        notif_v870: `Nicht unterstützte Dropbox-Paper- und Google-Drive-Dateien werden aus den zugehörigen Aufgaben ausgeschlossen; SFTP-Erfolgsrate verbessert und hängende temporäre Aufgaben behoben.`,
        notif_v831: `Fehler behoben, bei dem fehlgeschlagene temporäre Aufgaben als erfolgreich erschienen oder Übertragungsaufgaben im Wartezustand hängen blieben.`,
        notif_v830: `Fehler behoben, bei dem geplante Übertragungs-, Synchronisierungs- und Sicherungsaufgaben nicht rechtzeitig liefen; Aktivierung kostenpflichtiger Konten per Aktivierungscode hinzugefügt.`,
        notif_v780: `Web-Tools zum Herunterladen von Videos und Instagram-Inhalten ohne Installation hinzugefügt; SFTP-Erfolgsrate verbessert.`,
        notif_v760: `Originale Dateidaten bleiben nach der Synchronisierung erhalten.`,
        notif_v750: `Erfolgsrate der Übertragung für Google Fotos verbessert.`,
         notif_v740: `<b>Online-Video-Downloader</b>
<div>Laden Sie mit dem werbefreien, plattformübergreifenden Online-Video-Downloader von MultCloud hochwertige Videos von YouTube, Facebook, X, TikTok und über 1000 weiteren Seiten herunter – ohne Installation.</div>
<b>Probieren Sie diese neuen Funktionen jetzt aus und verbessern Sie Ihre Dateiverwaltungserfahrung mit MultCloud!</b>`,
         notif_v730: `<b>Web-Bild-Downloader</b>
<div>Sammeln Sie mühelos Bilder von jeder Website oder Google-Suche, indem Sie eine URL oder ein Stichwort eingeben, und speichern Sie sie direkt in Ihrem Cloud-Speicher oder auf Ihrem lokalen Gerät.</div>
<b>Probieren Sie diese neuen Funktionen jetzt aus und verbessern Sie Ihre Dateiverwaltungserfahrung mit MultCloud!</b>`,
         notif_v720: `<div>Wir freuen uns, neue Funktionen und Verbesserungen in MultCloud anzukündigen:</div>
<ol class="imagesaver_versions">
<li><b>Instagram-Downloader:</b><div>Sie können jetzt ganz einfach Instagram-Inhalte herunterladen! Mit dem neuen Instagram-Downloader können Nutzer Instagram-Profilbilder, Beiträge, Reels, Stories und Highlights direkt in den Cloud-Speicher oder auf Ihr lokales Gerät herunter- oder hochladen.</div></li>
<li><div>Der Video-Downloader und der Bild-Downloader werden ebenfalls bald verfügbar sein.</div></li>
</ol>`,
         notif_v710: `<div>Wir freuen uns, die neue Bildspeicher-Funktion in MultCloud vorzustellen! Hier sind die Details der neuen Funktionen:</div>
<ol class="imagesaver_versions">
<li><b>Instagram-Bilder und -Videos speichern</b>
<ul class="imagesaver_version">
<li type="disc"><b>Unterstützung mehrerer Links: </b>Speichern Sie Bilder und Videos von 1-3 Instagram-Links gleichzeitig.</li>
<li type="disc"><b>Einfaches Hoch- und Herunterladen: </b>Laden Sie Medien direkt in Ihren Cloud-Speicher hoch oder laden Sie sie auf Ihr lokales Gerät herunter.</li>
</ul></li>
<li><b>Website-Bilder speichern</b>
<ul class="imagesaver_version">
<li type="disc"><b>Unterstützung mehrerer Links: </b>Speichern Sie Bilder von 1-3 Website-Links auf einmal.</li>
<li type="disc"><b>Flexible Speicheroptionen: </b>Laden Sie Bilder direkt in Ihren bevorzugten Cloud-Speicher hoch oder laden Sie sie lokal herunter.</li>
</ul></li>
<li><b>Google-Suchbilder speichern</b>
<ul class="imagesaver_version">
<li type="disc"><b>Stichwortbasierte Suche: </b>Geben Sie ein Stichwort ein, um Bilder auf Google zu suchen.</li>
<li type="disc"><b>Direktes Speichern: </b>Laden Sie Suchergebnisse einfach in Ihren Cloud-Speicher hoch oder laden Sie sie auf Ihren Computer herunter.</li>
</ul></li>
</ol>`,
         notif_v700: `<div>MultCloud unterstützt jetzt 4shared und lDrive e2.</div>`,
         notif_v630: `<div>MultCloud unterstützt jetzt Icedrive.</div>`,
         notif_v620: `<div>Chrome-Erweiterung: MultCloud Save - Webseite als PDF speichern.</div>`,
         notif_v550: `<div>MultCloud unterstützt jetzt Outlook.</div>`,
         notif_v530: `<div>MultCloud unterstützt jetzt iCloud Drive.</div>`,
         notif_v520: `<div>MultCloud unterstützt jetzt Gmail.</div>`,
         notif_v500: `<div>MultCloud unterstützt jetzt iCloud Photos.</div>`,
         notif_v490: `<div>Fehlerbehebungen bei Cloud-Backup und -Wiederherstellung.</div>`,
         notif_v487: `<div>SharePoint-Online-Speicher wird unterstützt.</div>`,
         notif_v485: `<div>Share-Transfer.</div>
<div>Mit dieser Funktion können Sie große Dateien ganz einfach an jeden senden.</div>
<b>Kurzanleitung:</b>
<div>1.Klicken Sie mit der rechten Maustaste auf die Datei, die Sie senden möchten (um die Datei auszuwählen, fügen Sie bitte zuerst die Cloud, in der sich die Datei befindet, zu MultCloud hinzu).</div>
<div>2.Navigieren Sie zu "Teilen" und wählen Sie "Transfer erstellen".</div>`,
         notif_v482: `<div>Wasabi Cloud hinzugefügt.</div>
<div>Wasabi-Nutzer können Wasabi jetzt mit MultCloud verbinden.</div>`,
         notif_v480: `<div>Team-Transfer.</div>
<div>Migration von Business-Clouds von einem Mandanten zu einem anderen einfach gemacht. Google Workspace (und Shared Drive), OneDrive for Business, Dropbox Business, Box for Business werden unterstützt.</div>`,
         notif_v470: `<div>Cloud-zu-Cloud-Backup- und Wiederherstellungsfunktion hinzugefügt.</div>`,
         notif_v468: `<div>Alle Clouds werden für die Echtzeit-Synchronisierung unterstützt.</div>
<b>Verbessert :</b>
<div>UI auf der Teilen-Seite verbessert.</div>`,
         notif_v467: `<div>Cloud-zu-Cloud-Synchronisationsaufgaben unterstützen jetzt die Echtzeit-Synchronisierung.</div>
<b>Verbessert :</b>
<div>Geschwindigkeitsverbesserungen für neu erstellte Transfer- und Synchronisationsaufgaben.</div>`,
         notif_v465: `<div>1.Neue UI veröffentlicht.</div>
<div>2.Hochladen von Torrents in die Cloud unterstützt.</div>`,
         notif_v457: `<div>1.NAS hinzugefügt.</div>`,
         notif_v456: `<div>1.Das Problem, dass auf Google Photos nicht zugegriffen werden konnte, wurde behoben.</div>`,
         notif_v455: `<div>1.Die Funktion, MultCloud für kostenlosen Traffic zu teilen, verbessert.</div>`,
         notif_v454: `<div>1.Multi-Source-Transfer-Funktion hinzugefügt.</div>
<div>2.Online-Dateiverschlüsselung und -entschlüsselung hinzugefügt.</div>
<div>3.Option zur Dateinamenverschlüsselung zur Dateiverschlüsselungsfunktion hinzugefügt.</div>`,
         notif_v453: `<div>1.Dropbox for Business Cloud optimiert.</div>`,
         notif_v452: `<div>1.Neue Premium-Funktion: Datei-Upload-Verschlüsselung.</div>`,
         notif_v451: `<div>1.Verbesserungen am MultCloud-Transportserver.</div>
<div>2.Kostenlose und Premium-Pläne aktualisiert.</div>`,
         notif_v450: `<div>1.Papierkorb für einige Clouds hinzugefügt.</div>
<div>2.Einige Oberflächen unserer Website geändert.</div>
<div>3.Einige Funktionen optimiert.</div>`,
         notif_v444: `<div>1.Google Photos und Put.io hinzugefügt.</div>`,
         notif_v443: `<div>1.Einweg-Multi-Ziel-Synchronisationsfunktion hinzugefügt.</div>`,
         notif_v442: `<div>1.Backblaze hinzugefügt.</div>`,
         notif_v441: `<div>1.Google Drive für G Suite hinzugefügt.</div>`,
         notif_v440: `<div>1.Sub-Accounts-Verwaltung hinzugefügt.</div>
<div>2.Google Cloud Drive verbessert.</div>
<div>3.Einige Cloud-Drive-Bugs behoben.</div>`,
         notif_v431: `<div>1.OneDrive-for-Business-Autorisierungsfunktion verbessert und das Problem behoben, dass einige Nutzer diese Cloud nicht hinzufügen können.</div>
<b>Hinweis :</b>
<div>Bitte fügen Sie Ihre OneDrive-for-Business-Cloud und Transferaufgaben erneut hinzu, wenn Sie diese Cloud bereits hinzugefügt haben. Wir entschuldigen uns für die Unannehmlichkeiten.</div>`,
         notif_v430: `<div>1.Unterstützung für pCloud Drive hinzugefügt.</div>
<div>2.Einige Cloud-Drive-Bugs behoben.</div>`,
         notif_v420: `<div>1.Mehrsprachigkeit um Deutsch und traditionelles Chinesisch erweitert.</div>
<div>2.Dropbox Cloud Drive verbessert.</div>
<div>3.Teilungsfunktion verbessert und Hochlade- und Neue-Ordner-Aktionen auf der Teilen-Seite hinzugefügt.</div>`,
         notif_v410: `<div>1.Punktesystem hinzugefügt.</div>
<div>2.Verlauf-Fehler-Ansichtsfunktion hinzugefügt.</div>
<div>3.Manuelle Wiederholungsschaltfläche bei fehlgeschlagenem Transfer hinzugefügt.</div>
<div>4.Suche-, Teilen-, Transferfortschrittsfunktionen verbessert.</div>`,
         notif_v400: `<div>1.Cloud-Synchronisationsfunktion hinzugefügt, einschließlich Einweg-Sync, Zwei-Wege-Sync usw.</div>
<div>2.Unterstützung für OneDrive for Business, Dropbox for Business und Egnyte Cloud Drives hinzugefügt.</div>
<div>3.Teilen-Funktion verbessert.</div>
<div>4.UI verbessert.</div>
<div>5.Transfer-Bugs behoben.</div>`,
         notif_v380: `<div>1.Teilen-Funktion aktualisiert, Ordnerfreigabe, Freigabeverwaltung, Freigabe speichern, Freigabe übertragen hinzugefügt.</div>
<div>2.Option "Upload-URL" in der Upload-Funktion hinzugefügt.</div>
<div>3.Einige Cloud-Drive-Bugs behoben.</div>
<div>4.Copy Cloud Drive entfernt.</div>`,
         notif_v370: `<div>1.mega- und Evernote-Cloud-Drives hinzugefügt.</div>
<div>2.Vorschauunterstützung für Textdateien wie txt, html, js hinzugefügt.</div>
<div>3.Geplante Aufgaben optimiert.</div>
<div>4.Bug behoben, damit Google-Dokumente zwischen Google Drives mit konsistenten Dateitypen übertragen werden.</div>
<div>5.Amazon S3 unterstützt die Übertragung einzelner Dateien größer als 5 GB.</div>`,
         notif_v360: `<div>1.hubiC Cloud Drive hinzugefügt.</div>
<div>2.Funktion "Erlebnis ohne Registrierung" für schnelle Erfahrung hinzugefügt.</div>
<div>3.Funktion "Zur offiziellen Website" für einige Cloud Drives hinzugefügt.</div>
<div>4.Übertragungsbugs von OneDrive und Google Drive behoben.</div>`,
         notif_v350: `<div>1.Geschwindigkeit der Cross-Cloud-Übertragung für VIP-Nutzer verbessert.</div>
<div>2.MySQL-Backup und Flickr Cloud Drive hinzugefügt.</div>
<div>3.Einige Bugs bei der geplanten Übertragung behoben.</div>
<div>4.Bug behoben, dass Dateien von FTP und WebDav nicht aufgelistet werden konnten.</div>`,
         notif_v340: `<div>1.MediaFire zu MultCloud hinzugefügt.</div>
<div>2.OwnCloud zu MultCloud hinzugefügt.</div>
<div>3.Geplante Dateiübertragung geändert.</div>`,
         notif_v330: `<div>1.Alfreco zu MultCloud hinzugefügt.</div>
<div>2.aDrive zu MultCloud hinzugefügt.</div>
<div>3.Abbruch-Ausnahme bei der Übertragung zwischen verschiedenen Clouds geändert.</div>`,
         notif_v320: `<div>1.Option "Ersetzen" hinzugefügt.</div>
<div>2.OneDrive-API aktualisiert und einige Einschränkungen entfernt.</div>
<div>3.Bug des Amazon Cloud Drive behoben.</div>
<div>4.Übertragungsumgebung optimiert.</div>`,
         notif_v310: `<div>1.Amazon Cloud Drive unterstützt.</div>
<div>2.Ersetzen oder Überspringen einiger Dateien während der Dateiübertragung unterstützt.</div>
<div>3.SFTP-Dienst erweitert: Anmeldung mit privatem Schlüssel unterstützt.</div>
<div>4.Transfer-Funktion optimiert.</div>
<div>5.Einige Cloud-Drive-Bugs behoben.</div>`,
         notif_v300: `<div>1.Neue Funktionen wie Transfer und Task-Manager hinzugefügt.</div>
<div>2.Einstellung von geplanter Übertragung und Dateifilter unterstützt.</div>
<div>3.Automatische Benachrichtigung per E-Mail nach der Übertragung unterstützt.</div>
<div>4.Neubearbeitung der Konten und Anzeige der Eigenschaften von Cloud Drives unterstützt.</div>
<div>5.Einige UIs angepasst und optimiert.</div>
<div>6.Stabilität und Geschwindigkeit der Übertragung durch Optimierung der Netzwerkumgebung verbessert.</div>
<div>7.Einige Bugs behoben.</div>`,
         notif_v231: `<div>1.Schaltfläche "Hintergrund" entfernt, alle Übertragungsaufgaben werden standardmäßig in den Hintergrund gesetzt.</div>
<div>2.Einige Bugs behoben.</div>`,
         notif_v230: `<div>1.Funktion der Hintergrundübertragung hinzugefügt.</div>
<div>2.Übertragungsfähigkeit verbessert.</div>
<div>3.Funktion zur Anzeige der Größen von Cloud Drives hinzugefügt.</div>`,
         notif_v222: `<div>1.Funktion zur Anzeige eines Rechtsklick-Menüs für Tablets und mobile Geräte hinzugefügt.</div>
<div>2.Ausnahmen bei Registrierung und Passwort-Wiederherstellung geändert. Außerdem können Sie die Aktivierung zur Nutzung von MultCloud überspringen.</div>
<div>3.Ausnahme behoben, dass die Serveradresse, die mit http beginnt, für WebDav nicht hinzugefügt werden konnte.</div>`,
         notif_v221: `<div>1.Ausnahmen beim Auflisten, Suchen und Kopieren von Dateien von Google Drive geändert.</div>`,
         notif_v220: `<div>1.Bulk-Übertragungsausnahmen für höhere Übertragungsstabilität geändert.</div>
<div>2.Funktion zum Anzeigen der Details des Übertragungsfortschritts hinzugefügt.</div>`,
         notif_v210: `<div>1.Problem behoben, dass Dateilisten unvollständig angezeigt werden.</div>
<div>2.Ausnahmen beim Datei-Upload, -Download und -Übertragung in FTP geändert.</div>
<div>3.Abbruch-Ausnahme bei der Übertragung zwischen verschiedenen Clouds geändert.</div>
<div>4.UI zum Hinzufügen von FTP und WebDav geändert.</div>
<div>5.Einige Hinweise für jedes Cloud Drive hinzugefügt.</div>`,
         notif_v200: `<div>1.FTP zu MultCloud hinzugefügt.</div>
<div>2.WebDav zu MultCloud hinzugefügt.</div>
<div>3.Menüoption "Kopieren nach" hinzugefügt.</div>
<div>4.Anmeldung mit Google- und Facebook-Konto.</div>
<div>5.Benutzeroberfläche benutzerfreundlicher gestaltet.</div>
<div>6.Einige Bugfixes.</div>
<div>7.Unterstützung für Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy und BaiDu.</div>`,
         applicationKey: 'Anwendungsschlüssel',
         keyID: 'Schlüssel-ID',
         privateKey: 'Private Schlüsseldatei zur Authentifizierung (optional)',
         privateKey2: 'Privater Schlüssel',
         FTPTips:`1. Bitte stellen Sie sicher, dass Sie Lese- und Schreibberechtigungen vor Dateioperationen gesetzt haben ansonsten ist MultCloud nicht in der Lage, Dateien in Ihr FTP zu übertragen.
         2. Bitte stellen Sie sicher, dass genügend Speicherplatz vorhanden ist. Wir sind vorübergehend nicht in der Lage die Größe zu identifizieren.
         3. Wenn Sie nicht auf Ihr FTP zugreifen können, bitte fügen Sie 209.126.103.1/19 und 207.38.89.1/24 in die Firewall-Whitelist ein.`,
         specialDropBox:`Wenn Sie ein Dropbox Business-Administrator sind und auf alle Konten Ihrer Organisation zugreifen möchten, klicken Sie bitte auf „Zugang zur Organisation”.`,
         specialDropBoxBottom:`Wenn Sie auf Ihre persönliche Cloud zugreifen möchten, klicken Sie bitte auf „Zugang zur Personal Cloud”.`,
         accessOrganization:'Zugang zur Organisation',
         accessPersonalCloud:' Zugang zur Personal Cloud',
         specialBoxBusiness:'Wenn Sie ein box for Business-Administrator sind und auf alle Konten Ihrer Organisation zugreifen möchten, klicken Sie bitte auf „Zugang zur Organisation',
         specialgSuite:`Wenn Sie ein <a href='https://support.google.com/a/answer/2405986?hl=de' target="_blank" class='add-cloud-link'> Google Workspace-Administrator</a> sind und auf alle Konten Ihrer Organisation zugreifen möchten, „Admin Install” Sie bitte zuerst unsere Google Workspace Marketplace-App --- <a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=de" target="_blank" class='add-cloud-link'>„Cloud-Übertragung - MultCloud</a>”. Und dann klicken Sie auf „Zugang zur Organisation”.`,
         specialOnedrive:`Wenn Sie ein OneDrive for Business-Administrator sind und auf alle Konten Ihrer Organisation zugreifen möchten, klicken Sie bitte auf „Zugang zur Organisation”.`,
         iCloudPhotosTips:'MultCloud unterstützt derzeit keine Apple ID ohne E-Mail.',
         appleId: 'Apple-ID',
        addICloudPhotos: 'iCloud Fotos Hinzufügen',
        addICloudDrive: 'iCloud Drive Hinzufügen',
        fourShared: `Hinweis: 4shared-Autorisierung ist<span style="color: red"> 2 Stunden </span>lang gültig.  Bitte fügen Sie 4shared erneut hinzu und führen Sie Ihre Aufgaben nach Ablauf der Gültigkeit manuell aus.`,
        fourSharedTips: `Hinweis: 4shared-Autorisierung ist 2 Stunden lang gültig.  Bitte fügen Sie 4shared erneut hinzu und führen Sie Ihre Aufgaben nach Ablauf der Gültigkeit manuell aus.`,
     },
     cloudExploerPopup: {
        googlePhotosV2Tips: 'Tipps für Google Fotos',
        googlePhotosV2TipsDesc: 'Google hat die Google Fotos-API am 7. Mai 2025 aktualisiert. Um diesen Änderungen Rechnung zu tragen, müssen wir die folgenden Aktualisierungen implementieren:',
        googlePhotosV2Tips1: 'Der Ordner „Alben“ zeigt jetzt nur noch von MultCloud erstellte Alben an.',
        googlePhotosV2Tips2: 'Der Ordner „Fotos“ zeigt jetzt nur noch über MultCloud hochgeladene Bilder an.',
        googlePhotosV2Tips3: 'Um Bilder von Google Fotos in andere Cloud-Dienste zu übertragen, klicken Sie bitte auf „Weitere Fotos hinzufügen“ und gewähren Sie MultCloud Zugriff auf die gewünschten Bilder.',
        googlePhotosV2Tips4: 'Um Bilder von anderen Cloud-Diensten in Google Fotos zu übertragen, beachten Sie bitte, dass nur Ordner in den Ordner „Alben“ und nur einzelne Bilder in den Ordner „Fotos“ übertragen werden können.',
        googlePhotosV2TipsShow: 'Nicht mehr anzeigen',
        googlePhotosV2AddMore: 'Weitere Fotos hinzufügen',
        googlePhotosV2AddMoreTips: 'Klicken Sie hier, um die Bilder hinzuzufügen, die Sie zu MultCloud hinzufügen möchten.',
        googlePhotosV2FolderName: 'Ordnername',
        googlePhotosV2FolderNameInput: 'Geben Sie einen Namen für den Ordner ein, in dem die Bilder gespeichert werden sollen.',
        googlePhotosV2NotSelect: 'Sie haben noch kein Foto hinzugefügt. Klicken Sie auf „Weitere Fotos hinzufügen“, um Bilder zu MultCloud hinzuzufügen.',
        googlePhotosV2SelectAlbums: 'Ordner können nur in „Alben“ gespeichert werden.',
        googlePhotosV2SelectAlbum: 'Bilder und Videos können nur in diesem Ordner gespeichert werden.',
        googlePhotosV2SelectPhotos: 'Bilder und Videos können nur in „Fotos“ gespeichert werden.',
        googlePhotosV2SelectSession: 'Dieser Ordner kann nicht als Ziel ausgewählt werden. Bitte wählen Sie stattdessen den Ordner „Alben“ oder „Fotos“.',
        deleteContentEver: 'Sind Sie sicher, dass Sie die ausgewählten Elemente dauerhaft löschen möchten?<br>Einmal gelöscht, kann es nicht aus dem Papierkorb wiederhergestellt werden.',
        deleteContent: 'Möchten Sie die ausgewählten Elemente wirklich löschen?',
        deleteConfirm: 'Dateilöschung bestätigen?',
        removeSiteTitle: 'Website entfernen',
        removeSiteConfirm: 'Möchten Sie diese Website wirklich entfernen?',
        deleteAction: 'Diese Aktion kann nicht rückgängig gemacht werden. Die Datei wird dauerhaft gelöscht.',
        deleteDeletion: 'Bitte geben Sie den Dateinamen ein, um die Löschung zu bestätigen:',
        deleteDeletionOK: 'Bitte geben Sie den korrekten Dateinamen ein, um die Löschung zu bestätigen',
         detailedProgress: 'Detaillierter Prozess',
         highSpeed: 'Die Hochgeschwindigkeitssuche unterstützt die folgenden Cloud-Laufwerke',
         takeMoreTime: 'Bei den folgenden Cloud-Laufwerken kann es länger dauern',
         enterKeyWord: 'Geben Sie das Schlüsselwort ein',
         highSpeedSearch: 'Hochgeschwindigkeitssuche',
         normalSearch: 'Normale Suche',
         shareWithOthers: 'Mit anderen teilen',
         inviteByEmail: 'Personen per E-Mail einladen',
         pleaseEnterEmail: 'Bitte geben Sie E-Mails ein und trennen Sie sie durch Komma',
         addMessage: 'Nachricht hinzufügen(Optional)',
         shareTo: 'Teilen mit',
         noLink: 'Noch kein Link erstellt',
         createShare: 'Freigabe erstellen',
         cancelAllTask: 'Sind Sie sicher, dass Sie alle Aufgaben abbrechen möchten?',
         //xth
         shareEmailTitle: 'Link per E-Mail senden',
         shareNotSupportSource: 'Dieser Cloud-Dienst unterstützt diese Funktion nicht. Versuchen Sie bitte eine andere Freigabeoption.',
         shareSendEmail: 'E-Mail senden',
         generateLinkSuccess: 'Freigabelink erstellt.',
         generateLinkFail: 'Freigabelink konnte nicht erstellt werden.',
         emailSentSuccessful: 'E-Mails gesendet.',
         emailSentNull: 'Sie haben noch keine E-Mail eingegeben.',
         emailSentNotice: 'Bitte geben Sie eine korrekte E-Mail-Adresse ein.',
         linkCopySuccessful: 'Link kopiert!',
         sharePrivateLink: 'Privater Freigabelink: ',
         sharePrivatePassword: ' Passwort anzeigen: ',
         cancelMyShareTask: 'Sind Sie sicher, die Freigabe abzubrechen? Dieser Link funktioniert nicht mehr für alle, die ihn haben.',
         cancelMyShareOk: 'Ja, abbrechen',
         cancelMyShareNot: 'Nein, ich werde es behalten',
         emailArrayToLong50: 'Sie können 50 E-Mails gleichzeitig senden.',
         shareOnEmail: 'Link per E-Mail senden',
         shareOnFacebook: 'Auf Facebook teilen',
         shareOnTwitter: 'Auf Twitter teilen',
         shareOnTumblr: 'Auf Tumblr teilen',
         shareOnPinterest: 'Auf Pinterest teilen',
         shareOnLinkedIn: 'Auf LinkedIn teilen',
         ceateShareError: 'Die Freigabe konnte nicht erstellt werden, überprüfen Sie bitte Ihr Netzwerk.'
     },
     cloudTransferPopup: {
         pleaSelect: 'Bitte auswählen',
         schedule: 'Zeitplan',
         checkScheduled: 'Bitte überprüfen Sie das Kontrollkästchen \'Zeitplan\' dieser Aufgabe, um den Zeitplan-Editor zu aktivieren.',
         addValidCloud: 'Sie müssen ein gültiges Cloud-Speicher hinzufügen',
          //2020-10-26-ljm增加
          cleanList:'Liste bereinigen'
     },
     personalCenter: {
         changePassword: ' Passwort ändern',
         changeName: 'Name ändern',
         deleteAccount: ' Konto entfernen',
         enterPassWord: 'Bitte geben Sie Ihr Passwort ein',
         note: 'Hinweis: Bitte teilen Sie uns den Grund für Ihre Abreise mit. Wir werden unser Bestes geben, um dies zu korrigieren.',
         sureDeleteAccount: 'Sind Sie sicher, dass Sie dieses Konto entfernen möchten?',
         unsubscribe: 'Bevor Sie dieses Konto entfernen, müssen Sie MultCloud zuerst abbestellen.',
         bindEmail: 'E-Mail binden',
         pleaseSwitch: 'Bitte wechseln Sie zum klassischen MultCloud, um die Datei(en) zu entschlüsseln.',
         switchOld: 'Zu klassischer Version wechseln',
         pleaseUnsubscribe: 'Bitte wechseln Sie zu klassischem MultCloud, um Ihren Premium-Service zuerst abzubestellen.',
         deletePremium: 'Sie löschen gerade ein Premium-Konto. Sobald Sie es gelöscht haben, können Sie es nie mehr zurückerhalten. Sind Sie sicher, dies noch zu tun?'
     },
     remoteTaskPopup: {
         addLinkTask: ' Linkaufgabe hinzufügen',
         validLink: 'Bitte geben Sie einen gültigen Link ein',
         saveCloud: 'In Cloud speichern',
         parseFail:'Analyse fehlgeschlagen',
         inadmissibleRequest:'Die Anfrage wird nicht unterstützt',
         createBtTask: 'BT-Aufgabe erstellen',
         emptySource: 'Bitte geben Sie einen Link ein oder laden Sie eine Torrent-Datei hoch',
         validTorrent: 'The torrent file selected is invalid',
         addTorrent: 'Torrent hinzufügen',
         tip: ' Bitte wählen Sie ein Cloud-Laufwerk aus, um die Datei zu speichern',
         torrentSelected:'Name({num}/{all})',
         urlLinkSupported:'Kopieren Sie den Link hier und fügen Sie ihn ein. Die Links http/https /magnet werden unterstützt.\nHinweis: Verwenden Sie MultCloud nicht, um nicht autorisierte, verletzende kopierte Materialien herunterzuladen oder hochzuladen.',
         torrentStore:' Bitte wählen Sie eine Cloud aus, um die Torrent-Datei zu speichern.',
         downloadLink:'Bitte geben Sie einen Download-Link ein.',
         cancelTask:'Aufgabe abbrechen',
         cancelTaskContent:'Möchten Sie die Aufgabe wirklich abbrechen?',
         parseTaskRunning:'MultCloud führt bereits einen Analyseprozess aus. Gehen Sie zu „Remote-Upload“, um dies zu überprüfen.'
     },
     taskListPopup: {
         deleteTask: 'Aufgabe löschen',
         pleaseSelect: 'Bitte wählen Sie die Daten vor dem Löschen aus.',
         sureDeleteTask: 'Möchten Sie die Aufgabe(n) wirklich löschen?',
         deleteSingleTask: 'Möchten Sie die Aufgabe wirklich löschen?',
         viewLogs: 'Protokolle anzeigen',
         selectCloud: 'Bitte wählen Sie die Cloud aus, um die Dateien zu speichern'
     },
     upgradeAccountPopup: {
         commonTitle: '5 Cloud-zu-Cloud-Aufgaben parallel',
        commonDes: 'Bitte aktualisieren Sie zum Abonnenten und Sie können 5 Cloud-zu-Cloud-Aufgaben parallel laufen lassen.',
        upgradeAccount: 'Konto aktualisieren',
         upgradeHeadTitle:'Führen Sie 5 Link- oder Torrent-Aufgaben gleichzeitig aus.',
         upgradeHeadContent:"Kostenlose Benutzer können 1 Link- oder Torrent-Aufgabe gleichzeitig ausführen. Nach dem Upgrade auf Abonnenten können 5 Link- oder Torrent-Aufgaben gleichzeitig ausgeführt werden.",
         currentPlan: 'Aktueller Plan',
         insufficientTraffic: 'Unzureichende Cloud-zu-Cloud-Datenvolumen',
         insufficientTrafficDes: 'Sie haben alle kostenlose Datenvolumen dieses Monats verbraucht. Um mehr Datenvolumen zu erhalten, aktualisieren Sie bitte auf die Premium-Version.',
         filter: 'Dateiübertragung/Sync-Filter',
         filterDes: 'Um den Dateiübertragungs-/Synchronisierungsfilter zu aktivieren, aktualisieren Sie bitte auf die Premium-Version.',
         offlineFree: 'Führen Sie 1 Link- oder Torrent-Aufgabe gleichzeitig aus.',
         offlinePremium: 'Führen Sie 5 Link- oder Torrent-Aufgaben gleichzeitig aus.',
         modes: 'Erweiterte Synchronisationsmodi',
         modesDes: 'Abonnenten haben die Zwei-Wege-Synchronisation und 7 benutzerdefinierte Optionen in Einweg-Synchronisation. Unterstützt inkrementelles Backup & Sync.',
         doubleRealTime:'Double synchronisation en temps réel',
         doubleRealTimeSyncDes:'Mettez à jour l\'abonné et effectuez deux tâches de synchronisation en temps réel simultanément.',
         doubledSync: 'Double synchronisation normale',
         doubleSyncDes: 'Mettez à jour l\'abonné et effectuez deux tâches normales simultanément.',
         realTimeSyncing:'Double Synchronisation En Temps Réel',
         norMalSyncing:'Double Synchronisation Normale',
         free: 'Kostenlos',
         premium: 'Premium',
         monthTraffic: '5GB Datenvolumen/Monat',
         syncMode: '2 Synchronisierungsmodi',
         scheduled: 'Geplante Übertragung/Synchronisation/Backup',
         scheduledDes: 'Um die Zeitplanfunktion zu aktivieren, führen Sie bitte ein Upgrade auf die Premium-Version durch.',
         moreTraffic: 'Mehr Datenvolumen nach Bedarf',
         moreSyncModes: '8 Synchronisierungsmodi',
         transferSpeed: 'Schnellere Geschwindigkeit',
         doubleSync: 'Doppelte Synchronisierung',
         transferServer: 'VIP Transfer Server',
         customerSupport: 'VIP Kundendienst',
         syncSupported: 'Zwei-Wege-Synchronisation und 7 benutzerdefinierte Optionen in Einweg-Synchronisation. Unterstützt Spiegel-Synchronisation.',
         greatlyIncreased: 'Es gibt 10 Threads für Abonnenten anstelle von zwei, sodass die Übertragungsgeschwindigkeit erheblich erhöht wird.',
         sameTime: 'Abonnenten können 2 Echtzeit-Synchronisationsaufgaben und 2 normale Synchronisationsaufgaben (insgesamt 4) gleichzeitig ausführen lassen.',
         normalSametime:'Abonnenten können zwei normale Synchronisierungsaufgaben gleichzeitig ausführen.',
         automatically: 'Richten Sie einen Filter ein, um Dateien mit benutzerdefinierten Dateinamen oder bestimmten Erweiterungen automatisch zu übertragen oder zu synchronisieren.',
         multipleSync: 'Mehrere Synchronisierungsziele',
         multipleSyncDes: 'Upgrade auf Premium, um die Funktion mehrerer Synchronisierungsziele zu aktivieren.',
         freeDes:'Kostenlose Benutzer haben insgesamt 30GB Datenvolumen, um jeden Monat Daten zwischen Cloud-Speicherdiensten zu übertragen oder zu synchronisieren.',
         task1: 'Jeweils 1 Cloud-zu-Cloud-Aufgabe',
        task5: '5 Cloud-zu-Cloud-Aufgaben parallel',
        emailTitle: 'Unzureichende E-Mail-Konversionen',
        emailDes: 'Kostenlose Benutzer haben 50 E-Mail-Konvertierungen pro Monat, aber es sieht so aus, als bräuchten Sie mehr als das. Upgraden Sie auf Premium und Sie haben unbegrenzte E-Mail-Konvertierungen.',
        emailsConversions: '50 E-Mail-Konversionen/Monat',
        emailsUn: 'Unbegrenzte E-Mail-Konversionen',
     },
     remindBindEmail:{
         bindExe:'Bitte binden Sie Ihre E-Mail, um die Aufgabe auszuführen',
         onceBind:'Sobald Sie Ihre E-Mail gebunden haben, können Sie<span class="gift-flow">30GB</span>zusätzliche Datenvolumen von Cloud zu Cloud erhalten!',
         bindEmail:'Bitte binden Sie Ihre E-Mail, um die Kernfunktionen von MultCloud zu aktivieren.',
         coreFeatures:'Multcloud-Kernfunktionen',
         tourAccount:'Gastkonto',
         connectCloud:'Cloud Services mit MultCloud verbinden',
         viewCloud:'Alle Cloud-Dateien über MultCloud anzeigen',
         uploadFile:'Dateien über MultCloud in Clouds hochladen',
         downloadCloud:'Cloud-Dateien über MultCloud herunterladen',
         syncAndBackup:'Dateien zwischen Clouds synchronisieren und sichern',
         transferFiles:'Dateien von einer Cloud in eine andere übertragen',
         failed:'Fehler beim Ausführen des Vorgangs. Bitte versuchen Sie es später erneut.'
     },
     salePagePopup:{
         sOffer:'Sonderangebot für MONATLICH UNBEGRENZT',
         timeLimited:'Beeil dich, die Zeit ist begrenzt!',
         Hours:'Stunden',
         Minutes:'Minuten',
         Seconds:'Sekunden',
         monthPrice:'$19.9/Monat',
         dataTra:'für UNBEGRENZTE Datenvolumen',
         subscribe:'Jetzt abonnieren',
         features:'Funktionen',
         freePlan:'Kostenloser Plan',
         bigSale:'Zeitlich begrenzter Großverkauf',
         discountsto:'Rabatte bis zu',
         off:'25% Rabatt',
         premiumPlan:'Premium-Plan',
         transmit:'Datenvolumen zur Übertragung',
         dataTraffic:'Datenvolumen für Cloud-zu-Cloud-Dateiübertragung/-synchronisierung',
         originalPrice:'Originalpreis',
         nowOnly:'Jetzt Nur',
         getDiscount:'Rabatt bekommen',
         moreData:'Mehr Datenvolumen',
         unlimitedData:'Unbegrenzte Datenvolumen',
         syncModes:'Synchronisationsmodus',
         syncModesDes:'Abonnenten verfügen über Zwei-Wege-Synchronisierung und 7 benutzerdefinierte Optionen für die einseitige Synchronisierung. Spiegelung-Sync wird unterstützt.',
         scheduledTran:'Geplante Übertragung',
         scheduledTranDes:'Mit dieser Funktion können Sie automatische Cloud-zu-Cloud-Aufgaben in einem regelmäßigen Intervall oder zu einem bestimmten Zeitpunkt planen.',
         transferSpeedDes:'Es gibt 10 Threads statt 2 für Abonnenten, so ist die Übertragungsgeschwindigkeit stark erhöht.',
         fileEncryption:'Dateiverschlüsselung',
         encryptFiles:'Abonnenten können Dateien in Cloud-Diensten online verschlüsseln und hochladen.',
         quarterly:'vierteljährlich',
         yearly:'jährlich',
         monthGb:'150GB/Monat',
         monthGbly:'200GB/Monat',
         monthfourLy:'400GB/Monat',
         unTr:'Unbegrenztes Datenvolumen',
         nMonth:'/Monat',
         tQuarter:'/Viertel',
         eYear:'/Jahr',
         tOneTime:'Einmal',
          //2021-10-09
          premiumFeatures:'150 GB Datenvolumen mit allen Premium-Funktionen für einen Monat!',
          unlimitedYear:'Unbegrenztes Datenvolumen mit allen Premium-Funktionen für ein Jahr!',
          unlimitedLiftime:'Unbegrenztes Datenvolumen mit allen Premium-Funktionen auf Lebenszeit!',

     },
     giveawayActiveSucPopup: {
      headerTitle: "Einlösung erfolgreich!",
      headerSubtitle: "Ihr 3-monatiges Premium-Abo wurde aktiviert! Schalten Sie den Lebenslangen Unbegrenzten Plan mit einem exklusiven Rabatt von 80 % frei.",
      headerSubtitleYear: "Ihr 1-jähriges Premium-Abo wurde aktiviert! Schalten Sie den Lebenslangen Unbegrenzten Plan mit einem exklusiven Rabatt von 80 % frei.",
      currentPlanBadge: "Aktiviert",
      currentPlanName: "3 Monate Premium",
      currentPlanNameYear: "1 Jahr Premium",
      currentPlanPrice: "39,99 €",
      feature1: "3 Monate Premium-Funktionen",
      feature1Year: "1 Jahr Premium-Funktionen",
      feature2: "{traffic} Datenvolumen für 3 Monate",
      feature2Year: "{traffic} Datenvolumen für 1 Jahr",
      feature3: "Kundensupport an Werktagen",
      upgradePlanBadge: "80% Rabatt",
      upgradePlanName: "Lebenslang Unbegrenzt Premium",
      upgradePlanOriginalPrice: "628 €",
      upgradePlanCurrentPrice: "125,60 €",
      featureUpgrade1: "<b>Lebenslange</b> Premium-Funktionen",
      featureUpgrade2: "<b>Unbegrenztes</b> Datenvolumen",
      featureUpgrade3: "<b>24/7</b> VIP-Prioritätssupport",
      featureUpgrade4: "<b>90 Tage</b> Geld-zurück-Garantie",
      countdownLabel: "Exklusives Upgrade-Angebot endet in:",
      btnUpgrade: "Jetzt upgraden & 80 % sparen",
      promoText:  "für Lebenslang Unbegrenzt",
      off: "Rabatt",
    },
     properties: 'Eigenschaften',
     general: 'Allgemein',
     tips: 'Tipps',
     progress: 'Progzess',
     limits: 'Einschränkungen von Cloud-Laufwerke',
     detailed: 'Details',
     cancel: 'Alle abbrechen',
     simpleSync: 'Einfache Synchronisation',
     onewaySync: 'Einweg-Synchronisation',
     twowaySync: 'Zwei-Wege-Synchronisation',
     advancedSync: 'Erweiterte Synchronisierungsmodi',
     mirrorSync: 'Spiegel-Synchronisation',
     moveSync: 'Verschiebungs-Synchronisation',
     cmuSync: 'Kumulative-Synchronisation',
     updateSync: 'Aktualisierungs-Synchronisation',
     increSync: 'Inkrementelle Synchronisation',
     fullSync: 'Vollständige Sicherungs-Synchronisation',
     simpleSyncTip: 'Die hinzugefügten, geänderten und entfernten Dateien im Quellverzeichnis werden in das Zielverzeichnis repliziert. Die hinzugefügten, geänderten und entfernten Dateien im Zielverzeichnis werden jedoch nicht in das Quellverzeichnis repliziert.',
     mirrorSyncTip: 'Die Dateien in den Quell- und Zielverzeichnissen sind immer identisch (MultCloud entfernt die zusätzlichen Dateien im Zielverzeichnis).',
     moveSyncTip: 'Sobald die Synchronisation abgeschlossen ist, werden alle Dateien im Quellverzeichnis entfernt.',
     cmuSyncTip: 'Beim Entfernen der Dateien im Quellverzeichnis werden die gleichen Dateien im Zielverzeichnis nicht entfernt.',
     updateSyncTip: 'Alle Dateien im Zielverzeichnis werden zuerst entfernt und dann werden die hinzugefügten und geänderten Dateien im Quellverzeichnis in das Zielverzeichnis übertragen.',
     increSyncTip: 'Jedes Mal, wenn Sie Dateien synchronisieren, wird ein Unterverzeichnis im Zielverzeichnis erstellt, so dass die hinzugefügten und geänderten Dateien im Quellverzeichnis übertragen werden.',
     fullSyncTip: 'Jedes Mal, wenn Sie Dateien synchronisieren, wird ein Unterverzeichnis im Zielverzeichnis erstellt, so dass alle Dateien im Quellverzeichnis übertragen werden.',
     twowaySyncTip: 'Die hinzugefügten, geänderten und entfernten Dateien in dem Quellverzeichnis werden in das Zielverzeichnis repliziert. Ebenso werden die hinzugefügten, geänderten und entfernten Dateien aus dem Zielverzeichnis in das Quellverzeichnis repliziert. (Das bedeutet, dass die Dateien in den Quell- und Zielverzeichnis immer dieselben sind.)',
     clone: 'Klonen',
     syncModes: 'Synchronisationsmodi',
     email: 'E-Mail',
     filter: 'Filter',
     thread: 'Thread',
     listThread: 'Thread-Anzahl bei der Iteration',
     runThread: 'Anzahl der ausgeführten Threads',
     sameName: 'Gleicher Name',
     filterInclude: 'Eingeschlossene Erweiterungen (z. B. png, doc, mp4)',
     filterExclude: 'Auszuschließende Dateinamen (z. B. target, dist, build)',
     newFilterTag: 'Neues Tag',
     createTaskStatus: 'Erstellt',
     pendingTaskStatus: 'Wartend',
     runningTaskStatus: 'Wird ausgeführt',
     cancelledTaskStatus: 'Abgebrochen',
     completedTaskStatus: 'Erfolgreich',
     failedTaskStatus: 'Fehlgeschlagen',
     warnTaskStatus: 'Warnung',
     errorTaskStatus: 'Fehler',
     warning: 'Warnung',
     logs: 'Protokoll',
     once: 'Einmal',
     daily: 'Täglich',
     weekly: 'Wöchentlich',
     monthly: 'Monatlich',
     onlyOnce: 'Läuft nur einmal am:',
     everyDay: 'Läuft jeden Tag um:',
     everyWeek: 'Jede Woche am:',
     at: 'bei:',
     sunday: 'Sonntag',
     monday: 'Montag',
     tuesday: 'Dienstag',
     wednesday: 'Mittwoch',
     thursday: 'Donnerstag',
     friday: 'Freitag',
     saturday: 'Samstag',
     runAt: 'Läuft am:',
     lastDay: 'Letzter Tag',
     chooseAction: 'Wenn die Zieldatei bereits vorhanden ist, wählen Sie bitte eine Aktion:',
     optionsPrompt: 'Wenn Dateien in der Quell-Cloud einen Dateiname mit Sonderzeichen haben, den in der Ziel-Cloud nicht zulässig ist, werden die Dateien während des Übertragungsprozesses automatisch umbenannt und eine log.html Datei wird im Stammverzeichnis auf der Ziel-Cloud erstellt.',
     sourceNewer: 'Überschreiben, wenn die Quelle neuer ist.',
     diffSize: 'Überschreiben, wenn die Größe unterschiedlich ist.',
     sourceAll: 'Überschreiben, wenn die Größe unterschiedlich oder die Quelle neuer ist.',
     skipFile: 'Die Datei überspringen.',
     skipEmail: 'Überspringen Sie die E-Mail.',
     overWrite: 'Immer überschreiben.',
     rename: 'Umbenennen',
     overWriteSourceNewer: 'Bei einer Aktualisierung der ursprünglichen E-Mail wird diese überschrieben. ',
     deleteAllSource: 'Entfernen Sie alle Quelldateien, nachdem die Übertragung abgeschlossen ist.',
     keepFileDate: 'Behalte das Datum der Dateiänderung (Unterstützt Dropbox, Google Drive, G Suite).',
     automaRename: 'Automatische Umbenennung der Dateien mit Sonderzeichen und Erzeugen einer Skriptdatei.',
     sendEmail: 'E-Mail-Benachrichtigung senden, wenn diese Aufgabe abgeschlossen ist.',
     sendMessage: 'Testnachricht senden',
     ignoreFiles: 'Dateien mit diesen Erweiterungen ignorieren',
     includeFiles: 'Nur Dateien mit diesen Erweiterungen einschließen',
     selectSync: 'Hier können Sie den Synchronisierungsmodus auswählen:',
     tipsFor: 'Tipps für',
     allTasks: 'Alle Aufgaben',
     successful: 'Erfolgreich',
     unfinished: 'Unerledigt',
     transferDetails: 'übertragungsdetails',
     redit: 'Erneut bearbeiten',
     publicShare: 'Öffentliche Freigabe',
     publicTip: 'Tipps: Jeder, der den Link erhält, kann die Datei anzeigen',
     privateShare: 'Privatfreigabe',
     privateTip: 'Tipps: Andere müssen ein Passwort eingeben, um die Datei anzuzeigen',
     sourceShare: 'Quellfreigabe',
     sourceTip: 'Tipps: Ein Freigabelink wird für die Quell-Cloud erstellt',
     shareSuccess: 'Freigabe erfolgreich erstellen',
     copySuccess: 'Erfolgreich kopieren',
     sharedYet: "Diese Datei wurde bereits freigegeben",
     domain: 'Domain',
     code: 'Code',
     resendCode: 'Code erneut senden',
     key: 'Key',
     secret: 'Secret',
     //2020-10-26-ljm增加
     progressBox:'Progzess',
     //xth
     publicShareEasy: 'Alle',
     privateShareEasy: 'Privat',
     communityShareEasy: 'Öffentlich',
     sourceShareEasy: 'Quelle',
     reportPopup: {
         title: 'Bericht teilen',
         beforeMsgOne: 'Helfen Sie uns zu verstehen, was mit dieser Freigabe passiert.',
         beforeMsgTwo: 'Wie würden Sie es beschreiben?',
         typeItems: {
             spam: 'Spam',
             malwareVirus: 'Malware oder Virus',
             copyrightViolation: 'Urheberrechtsverletzung',
             illegal: 'Illegaler Inhalt',
             notWorking: 'MultCloud funktioniert nicht richtig.',
             other: 'Andere unangemessene Inhalte',
         },
         nextMsgOne: 'Bitte geben Sie die Informationen zu diesem Bericht ein.',
         description: 'Beschreibung',
         nextMsgTwo: 'Beschreiben Sie, was mit der Freigabe passiert.',
         yourEmail: 'Ihre E-Mail',
         nextMsgThree: 'Bitte geben Sie Ihre E-Mail-Adresse an und wir können uns bei Bedarf an Sie wenden.',
         submit: 'Absenden',
         back: 'Zurück',
         next: 'Weiter',
         messageNone: 'Bitte geben Sie die Beschreibung dieses Berichts ein.',
         emailNone: 'Bitte geben Sie Ihre Kontakt-E-Mail ein.',
         success: 'Ihr Bericht wurde bereits an das MultCloud-Team gesendet.'
     },
     subAccountPopup:{
         title: "Verwaltung von Unterkonten",
         titleMax: "Verwaltung von Unterkonten",
         titleDes:"Bitte führen Sie ein Upgrade auf Abonnent durch und Sie können Unterkonten erstellen und verwalten.",
         tabNameUser: "Benutzermodus",
         tabNameItem: "Ordnermodus",
         addItemButton: "Zugewiesener Ordner",
         users: "Benutzer",
         folders: "Ordner",
         read: "Lesen",
         write: "Schreiben",
         questionTxtRead: "Benutzer von Unterkonten können in diesem Ordner Dateien herunterladen, in der Vorschau anzeigen und in ihre Clouds kopieren.",
         questionTxtWrite: "Benutzer von Unterkonten können in diesem Ordner neue Ordner erstellen, Dateien hochladen, löschen und umbenennen.",
         userExist:"Der Benutzer existiert bereits.",
         userSelf:"Sie können sich selbst nicht als Unterkonto hinzufügen.",
         quickAssign: "Schnell zuweisen",
         quickAdd: "Schnell hinzufügen",
         allow: "Zulassen",
         batchAddUserNull: "Es wurde noch kein Benutzer hinzugefügt.",
         batchAddItemNull: "Es ist noch kein Ordner hinzugefügt.",
         noUserFromAddItem: "Bitte fügen Sie zuerst einen Benutzer hinzu.",
         noItemFromAddUser: "Bitte fügen Sie zuerst einen Ordner hinzu.",
         addUser: {
             title: "Benutzer hinzufügen",
             radioCreate: "Ein Unterkonto erstellen",
             radioAdd: "Ein vorhandenes MultCloud-Konto hinzufügen",
             createNamePlaceholder: "Benutzernamen erstellen",
             createPasswordPlaceholder: "Kennwort erstellen",
             addNamePlaceholder: "Bitte geben Sie das vorhandene MultCloud-Konto ein.",
             createNameNone: "Bitte geben Sie einen Benutzername ein.",
             createNameMore: "Der Benutzername sollte weniger als 20 Zeichen enthalten.",
             createPasswordNone: "Bitte geben Sie ein Kennwort ein.",
             createPasswordError: "Bitte geben Sie ein Kennwort mit 8-16 Zeichen ein.",
             addUserNameNone: "Bitte geben Sie ein vorhandenes MultCloud-Konto ein.",
             addUserNone: "Dieses Konto existiert nicht.",
         },
         addItem: {
             noFolder: "Bitte wählen Sie einen Ordner.",
             exist: "Sie haben bereits den Ordner hinzugefügt.",
         },

         editUser: {
             title: "Unterkonto bearbeiten",
             namePlaceholder: "Benutzernamen eingeben",
         },
         cancel: {
             titleUser: "Unterkonto löschen",
             titleItem: "Ordner entfernen",
             msgUser: "Sind Sie sicher, dieses Konto zu löschen?",
             msgItem: "Sind Sie sicher, diesen Ordner zu entfernen?",
         },
         unknownError: "Der Pfad kann nicht gefunden werden. Überprüfen Sie, ob der Pfad vorhanden ist, oder fügen Sie die Cloud erneut hinzu.",
 },
 verifyPopup:{
     verifyTitle: "Ihre Identität überprüfen",
         toRecoveryText: "Ich habe keine von diesen",
         verifyEmailTitle: "Ihre E-Mail überprüfen",
         verifyEmailTips: "Wir senden einen Verifizierungscode an {email}. Um zu überprüfen, ob dies Ihre E-Mail-Adresse ist, geben Sie sie unten ein.",
         verifyPhoneTitle: "Ihr Telefonnummer überprüfen",
         verifyPhoneTips: "Wir senden einen Verifizierungscode an {phone}. Um zu überprüfen, ob dies Ihre Telefonnummer ist, geben Sie die letzten 4 Ziffern einschließlich {last} ein.",
         verifyPhoneText: "Letzte 4 Ziffern der Handynummer",
         sendCodeBtn: "Code senden",
         enterCode: "Code eingeben",
         checkEmailTips: "Wenn {email} mit der alternativen E-Mail in Ihrem Konto übereinstimmt, senden wir Ihnen einen Code.",
         checkPhoneTips: "Wenn {phone} mit den letzten 4 Ziffern der Telefonnummer auf Ihrem Konto übereinstimmt, senden wir Ihnen einen Code.",
         askDevice: "Fragen Sie mich nicht noch einmal bei diesem Gerät.",
         verify: "Überprüfen",
         recoveryTitile: "Haben Sie einen Kontowiederherstellungscode?",
         recoveryTipsOne: "Wenn Sie einen Wiederherstellungscode haben, geben Sie ihn jetzt ein. Wenn Sie keinen haben, wenden Sie sich bitte an",
         recoveryTipsTwo: "Ihr Wiederherstellungscode ist 25 Zeichen lang und sieht wie folgt aus: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
         recoveryCode: "Wiederherstellungscode",
         recoveryCodeBtn: "Wiederherstellungscode verwenden",
         recoveryChangeTitile: "Wie können wir Ihre Identität noch verifizieren?",
         recoveryEmailChange: "Alternative E-Mail-Adresse hinzufügen",
         recoveryPhoneChange: "Einer Telefonnummer hinzufügen",
         enterEmail: "Ihre E-Mail eingeben",
         recoveryNextTitle: "Bitte geben Sie den Code ein, den wir an {checkCode} senden",
         recoveryTipsTitle: "Zu Ihrem Schutz dauert das Ersetzen Ihrer Sicherheitsdaten 30 Tage!",
         recoveryTips1: "Da Sie die zweistufige Überprüfung aktiviert haben, benötigen Sie aktuelle Sicherheitsinformationen, um sich bei Ihrem Konto anzumelden.",
         recoveryTips2: "Während der Wartezeit können Sie sich nicht mit Ihrem Konto bei Websites oder Diensten anmelden, aber Sie können sich bei Geräten anmelden.",
         recoveryTips3: "Sie können die Wartezeit vermeiden, indem Sie:",
         recoveryTips4: "Verwendung eines vertrauenswürdigen Geräts.",
         recoveryTips5: "Wenn Sie ein Gerät haben, für das keine Codes erforderlich sind, verwenden Sie es jetzt und aktualisieren Sie Ihre Sicherheitsinformationen.",
         recoveryTips6: "Finden Sie Ihre Sicherheitsinformationen.",
         recoveryTips7: "Besteht die Möglichkeit, dass es nicht ganz verloren ist? Wenn Sie sie finden können, verwenden Sie sie jetzt, um Ihr Konto wieder zu aktivieren.",
         recoveryTips8: "Die Wartezeit macht es für jemand anderen schwieriger, Ihr Konto mit einem gestohlenen Passwort zu übernehmen.",
         recoveryPendTitle: "Die Änderung Ihrer Sicherheitsinformationen steht noch aus",
         recoveryPendTips1: "Am {Daten} haben Sie angefordert, dass Ihre Sicherheitsinformationen ersetzt werden",
         recoveryPendTips2: "Aktuelle Sicherheitsinfos",
         recoveryPendTips3: "Alternative E-Mail:",
         recoveryPendTips4: "Telefon-Nummer:",
         recoveryPendTips5: "Neue Sicherheitsinfo",
         recoveryPendTips6: "Wenn Sie Ihre aktuelle Sicherheitsinfos beibehalten möchten,",
         recoveryPendTips7: "Diese Anfrage abbrechen.",
         recoveryCancelTitle: "Hier ist Ihr neuer Wiederherstellungscode",
         recoveryCancelTips1: "Um Ihr Konto zu sichern, benötigen Sie einen neuen Wiederherstellungscode.",
         recoveryCancelTips2: "Wenn Sie jemals den Zugriff auf Ihr Konto wiederherstellen müssen, wird dieser Code helfen. Sie sollten ihn aufschreiben und an einem sicheren Ort aufbewahren. Wir empfehlen dringend, dass Sie Ihren Wiederherstellungscode nicht auf einem Gerät speichern.",
         recoveryCancelTips3: "Wenn Sie zuvor einen Wiederherstellungscode hatten, ist dieser nicht mehr gültig. Verwenden Sie stattdessen diesen neuen Code.",
         recoveryCancelTips4: "Ihr neuer Code lautet:",
         recoveryCancelSucTitle: "Super! Lassen Sie uns wieder in Ihr Konto gehen!",
         recoveryCancelSucTips1: "Das Sicherheitsinformations-Update für {old} wurde abgebrochen, und Sie haben jetzt vollen Zugriff auf Ihr Konto.",
         recoveryCancelSucTips2: "Die Kontaktinformationen, die zum Starten des Prozesses verwendet wurden ({neu}), wurden entfernt und werden nicht als Sicherheitsinformationen für Ihr Konto verwendet.",
         recoveryCancelSucTips3: "Klicken Sie auf \„Weiter\”, um zu dem zurückzukehren, was Sie gerade getan haben.",
         recoveryCancelErrorTitle: "Anfrage einreichen",
         recoveryCancelErrorTips: "Ihr Konto befindet sich noch in der Wartezeit.",
         codeText: "Geben Sie Ihre Handynummer ein",
         exception: {
             emailTwoStringError: "Die korrekte E-Mail beginnt mit \„{errorCode}\”.",
             validEmail: "Bitte geben Sie eine korrekte E-Mail ein.",
             phoneLastTwoStringError: "Die richtige Nummer endet auf {errorCode}.",
             validPhone: "Sie müssen die letzten 4 Ziffern der Rufnummer eingeben.",
             verificationCodeExpired: "Der Verifizierungscode ist abgelaufen.",
             verificationCodeError: "Der Verifizierungscode ist falsch, bitte überprüfen Sie den Code und versuchen Sie es erneut.",
             verificationRecoveryCodeExpired: "Der Code hat nicht funktioniert, bitte überprüfen Sie den Code und versuchen Sie es erneut.",
             verificationCodeNull: "Bitte geben Sie einen Verifizierungscode ein.",
         }
 },
 worldBackupPopup: {
     //title:'World Backup Day',
     title:'MultCloud Sonderangebot',
     titleTip:'24-Stunden-Blitzverkauf',
     timerTitle:'Das Angebot ist zeitlich begrenzt und endet in ...',
     getOffer:'Angebot Erhalten',
     tips100Mo:'100GB/M Datenvolumen',
     ps100Mo:'Tipps: Das ungenutzte Datenvolumen sammelt sich an. Wenn Sie z. B. im ersten Monat nur 50GB von 100GB verbraucht haben, haben Sie im nächsten Monat immer noch 50GB zusätzliche Datenvolumen.',
     tips1200Yr:'1200GB/J Datenvolumen',
     ps1200Yr:'Tipps: Das ungenutzte Datenvolumen sammelt sich an.Sie haben z. B. im ersten Jahr nur 1000GB von 1200GB verbraucht und werden im nächsten Jahr noch 200GB zusätzlichen Datenverkehr haben.',
     tips2400Yr:'2400GB/J Datenvolumen',
     ps2400Yr:'Tipps: Das ungenutzte Datenvolumen sammelt sich an.Sie haben z. B. im ersten Jahr nur 2000GB von 2400GB verbraucht und werden im nächsten Jahr noch 400GB zusätzlichen Datenverkehr haben.',
     tipsUnYr:'Unbegrenzt/J Datenvolumen',
     psUnYr:'Tipps: Unbegrenztes Datenvolumen für ein Jahr!',
     tipsUnLi:'Unbegrenzt/Lebenslang Datenvolumen',
     psUnLi:'Tipps: Unbegrenztes Datenvolumen auf Lebenszeit!',
     tips1:'10 Threads zur Dateiübertragung',
     tips2:'Geplante Cloud-Übertragung',
     tips3:'24/7/365 vorrangige Support',
     ps1:'Es gibt 10 Threads für Abonnenten und 2 für kostenlose Nutzer, so dass die Übertragungsgeschwindigkeit deutlich erhöht wird.',
     ps2:'Abonnenten können die automatische Übertragung/Synchronisierung von Cloud zu Cloud in regelmäßigen Abständen oder zu einem bestimmten Zeitpunkt planen.',
     moPrice:'{price} / Monat',
 },
 iosPayTipPopup: {
    title: 'Apple-Abonnement kündigen',
    tip: 'Ihre aktuellen {name} sind im Status der automatischen Verlängerung (Apple Transaktions-ID: {id}), bitte kündigen Sie das Abonnement und versuchen Sie es erneut.',
    btnTxt: 'Wie man kündigt',
},
appRecommendPopup: {
    title: 'Die neue MultCloud Mobile App ist jetzt verfügbar!',
    tip: 'Sofortiger Download zur Verwaltung und Übertragung von <br>Daten über Clouds mit mobilen Geräten.',
    modileTitle: 'Jetzt die MultCloud Mobile App herunterladen!',
    iosBtnTitle: 'Laden im',
    iosBtnTip: 'App Store',
    androidBtnTitle: 'JETZT BEI',
    androidBtnTip: 'Google Play',
    apkBtnTitle: 'MultCloud',
    apkBtnTip: 'herunterladen',
},
note: 'Hinweis',
    editCloudNoticPopup: {
        tips: 'Die Autorisierung ist abgelaufen, bitte fügen Sie die Cloud erneut zu MultCloud hinzu und versuchen Sie es erneut.',
        btnTxt: 'Neu hinzufügen',
    },
    appleTipsPopup: {
        title: 'Tipps',
        tipTitle: 'Tipps für iCloud-Photos 2-Faktor-Authentifizierung',
        tip1: 'Um Ihre iCloud-Fotos mit MultCloud zu verbinden, müssen Sie dem MultCloud-Server Zugriff auf Ihre Apple-ID gewähren. Daher sehen Sie möglicherweise, dass sich unser Serverstandort während des 2-Faktor-Authentifizierungsverfahrens von Ihrem tatsächlichen Standort unterscheidet.',
        tip2: 'Und bitte denken Sie daran: Ihre Sicherheit und Privatsphäre ist unsere oberste Priorität. MultCloud speichert Ihre Daten nicht dauerhaft. Es kann einen Teil des Inhalts basierend auf Ihren Vorgängen vorübergehend zwischenspeichern, wird jedoch sofort von unserem Server entfernt, sobald der Vorgang abgeschlossen ist. Und die Verbindung zwischen Ihren iCloud-Fotos und MultCloud-Servern erfolgt immer über einen sicheren 256-Bit-SSL-Kanal.',
        checkTip: 'Nicht mehr zeigen',
    },
    iCloudDriveTips: {
        title: 'Tipps',
        tipTitle: 'Tipps für iCloud Drive 2-Faktor-Authentifizierung',
        tip1: 'Um Ihr iCloud Drive mit MultCloud zu verbinden, müssen Sie dem MultCloud-Server Zugriff auf Ihre Apple ID gewähren. So können Sie sehen, dass unser Serverstandort von Ihrem tatsächlichen Standort während des 2-Faktor-Authentifizierungsverfahrens abweicht.',
        tip2: 'Und denken Sie bitte daran: Ihre Sicherheit und Privatsphäre hat für uns oberste Priorität. MultCloud speichert Ihre Daten nicht dauerhaft. Es kann sein, dass ein Teil des Inhalts vorübergehend zwischengespeichert wird, aber er wird sofort von unserem Server entfernt, sobald der Vorgang abgeschlossen ist. Und die Verbindung zwischen Ihrem iCloud Drive und den MultCloud-Servern wird immer über einen sicheren 256-Bit-SSL-Kanal hergestellt.',
        checkTip: 'Nicht mehr zeigen',
    },
    checkApplePopup: {
        title: 'Zwei-Faktor-Authentifizierung',
        tip1: 'Sie haben die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den Bestätigungscode auf Ihrem iPhone/iPad/iPod ein, um fortzufahren.',
        tip2: 'Sie haben keinen Verifizierungscode erhalten?',
        btn1: 'Nachricht senden...',
        btn2: 'Code erneut senden',
        btn3: 'Schicke mir eine SMS',
        btn4: 'Unterstützung erhalten',
        suc1: 'Eine Nachricht mit einem Verifizierungscode wurde an {num} gesendet.',
        suc2: 'Eine Nachricht mit einem Verifizierungscode wurde an Ihre Geräte gesendet.',
        fail1: 'Verifizierung fehlgeschlagen, bitte überprüfen Sie den Verifizierungscode und geben Sie ihn erneut ein.',
        fail2: 'Bitte geben Sie den Verifizierungscode ein, um fortzufahren.',
    },
    downloadThreadPopup: {
        title: "Einstellungen herunterladen",
        tips: "Name auf der heruntergeladenen Datei",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "Anhänge speichern",
        option2: "Gesprächsformat",
        option2Tips: "Zitate werden bei Aktivierung entfernt.",
        option3: "Nur die letzte Nachricht speichern",
    },
    failedFilesPopup: {
        title: 'Fehlgeschlagene Dateien anzeigen: {num}',
        exportExcel: 'Nach Excel exportieren',
        retrySucTip: '{num} Elemente wurden zur Wiederholungsliste hinzugefügt.',
    },
    viewLogsPopup: {
        title: 'Aufgabendetails:',
        titleRe: 'Wiederherstellungsdetails:',
        errorNum: 'Fehlernummer',
        addNum: 'Datei(en) hinzufügen',
        updateNum: 'Datei(en) ändern',
        deleteNum: 'Datei(en) löschen',
        syncSize: 'Synchronisationsgröße',
        syncTime: 'Synchronisationsdauer',
        backupNum: 'Anzahl der Backups',
        backupSize: 'Größe der Backups',
        backupTime: 'Größe der Backups',
        restoreNum: 'Anzahl der Wiederherstellungen',
        restoreSize: 'Wiederherstellungsgröße',
        restoreTime: 'Wiederherstellungszeit',
        cloneNum: 'Anzahl der Klonvorgänge',
        cloneSize: 'Klongröße',
        cloneTime: 'Klonzeit',
        tranNum: 'Anzahl der Übertragungen',
        tranSize: 'Übertragungsgröße',
        tranTime: 'Übertragungsdauer',
        from: 'Quelle：',
        to: 'Ziel：',
        executeTime: 'Ausführungszeitraum:',
        sourceAccount:'Quellkonto',
        targetAccounts:'Zielkonten',
        executeResult: 'Ausführungsergebnis',
        add: 'Hinzufügen:',
        update: 'Aktualisieren:',
        delete: 'Löschen:',
    },
    taskProgressPopup: {
        title1: 'Sie sind ein Premium-Nutzer und können jetzt 10 Dateien gleichzeitig übertragen.',
        title2: 'Upgraden Sie auf einen beliebigen Premium-Dienst, um bis zu 10 gleichzeitig zu erreichen!',
        btnTip: 'Schon ab $9.99',
    },
    subfileSelectPopup: {
        title: 'Upload-Inhalt auswählen',
    },
    deleteBatchPopup: {
        tips1: 'Sind Sie sicher, dass Sie diese <span>{num}</span> Aufgabe(n) löschen möchten?',
        tips2: 'Nach dem Löschen können die Aufgaben nicht wiederhergestellt werden.',
    },
    freeSaledPopup: {
        tips1: 'Halten Sie die Erinnerungen deiner Familie über verschiedene Clouds hinweg miteinander verbunden – sichern Sie 10 GB GRATIS zum Family Day!',
        tips2: 'Warten!',
        tips3: 'Sieht so aus, als würden Sie auf Ihr Vatertagsgeschenk verzichten. Nur zur Erinnerung: Einmal abgewählt, ist es weg!',
        btns1: '10 GB sichern',
        btns2: 'Nein, danke',
        success: 'Glückwunsch! Sie haben gerade 10 GB Cloud-übergreifenden Transferverkehr erhalten. ',
        floatTitle: '10 GB GRATIS',
        popupTitle: '<span>10 GB</span> GRATIS',
    }
},
 addCloud: {
     connectDesc: 'Wählen Sie einen Dienst aus, um eine Verbindung herzustellen.',
     box: 'box',
     boxBusiness:'box for Business',
     dropbox: 'Dropbox',
     google_drive: 'Google Drive',
     google_drive_sharedWithMe: 'Für mich freigegeben',
     google_drive_v2: 'Google Drive',
    google_drive_shared_v2: 'Für mich freigegeben',
     oneDrive: 'OneDrive',
     oneDriveV2: 'OneDrive',
     sugarSync: 'SugarSync',
     amazonS3: 'Amazon S3',
     iDrivee2: 'IDrive® e2',
     wasabi:'Wasabi',
     webDav: 'WebDAV',
     FTP: 'FTP',
     NAS: 'NAS',
     cloudMe: 'CloudMe',
     cubby: 'Cubby',
     myDrive: 'MyDrive',
     yandex: 'Yandex',
     hiDrive: 'HiDrive',
     WEBDE: 'WEB.DE',
     baiDu: 'BaiDu',
     amazon: 'Amazon',
     alfresco: 'Alfresco',
     aDrive: 'ADrive',
     Icedrive: 'Icedrive',
     oneDrive4Business: 'OneDrive for Business',
     dropbox4Business: 'Dropbox Business',
     pCloud: 'pCloud',
     mega: 'MEGA',
     backblaze: 'Backblaze',
     putio: 'Putio',
     googlePhotos: 'Google Photos',
     googlePhotosV2: 'Google Photos',
     gSuiteSharedDrive: 'Geteilte Ablagen',
     evernote: 'Evernote',
     flickr: 'Flickr',
     mediafire: 'MediaFire',
     ownCloud: 'ownCloud',
     mySQL: 'MySQL',
     gSuite: 'Google Workspace',
     hubiC: 'hubiC',
     egnyte: 'Egnyte',
     youtube1: 'youtube1',
     facebook: 'facebook',
     picasa: 'picasa',
     goDaddy: 'goDaddy',
     ubuntu: 'ubuntu',
     welcomeTo: 'Willkommen bei MultCloud',
     peCloud: 'Persönliche Dienste',
     buCloud: 'Geschäftsdienste',
     welcomeFont: 'Jetzt können Sie problemlos mehrere Cloud-Dateien mit einer App übertragen und verwalten. Zuerst verbinden Sie Ihre Cloud mit MultCloud',
     sharePointOnline:"SharePoint Online",
     iCloudPhotos: 'iCloud Fotos',
     gmail: 'Gmail',
     comingSoon: 'Kommt bald...',
     iCloudDrive: "iCloud Drive",
     signInWith: 'Anmelden mit',
     outlook: 'Outlook',
     fourShared: '4shared',
 },
 addEmail: {
    connectDesc: 'Klicken Sie auf die E-Mail, um sie mit MultCloud zu verbinden',
    peEmail: 'Wählen und melden Sie sich mit der E-Mail an',
    iCloudNotice: 'iCloud Drive kann vorübergehend keine Verbindung herstellen und unser Entwicklungsteam arbeitet derzeit an der Lösung des Problems.',
    iCloudPhotosNotice: 'iCloud Fotos kann vorübergehend keine Verbindung herstellen und unser Entwicklungsteam arbeitet derzeit an der Lösung des Problems.',
},
cloudExploer: {
     uploadFile: 'Datei hochladen',
     newFolder: 'Neuer Ordner',
     newAlbum: 'Neues Album',
    search: 'Suche',
     grid: 'Gitter',
     pageList: 'List',
     reFresh: 'Aktualisieren',
     modified: 'Geändert am',
     openWith: 'Öffnen mit',
     officeOnline: 'Microsoft Office Online',
     loading: 'Bitte warten, laden...',
     uploadFolder: 'Ordner hochladen',
     trash: 'Papierkorb',
     recentlyDeleted: 'Zuletzt gelöscht',
     jumpTo: 'Springe zu',
     deleteForever: 'Für immer entfernen',
     restore: 'Wiederherstellen',
     back: 'Zurück',
     searchResult: 'Suchergebnis',
     emptyTrash: 'Entleeren des Papierkorbs',
     recoverAll: 'Alle wiederherstellen',
     deleteAll: 'Alle löschen',
     fileExists: 'Datei existiert',
     chooseOption: 'Datei existiert, bitte wählen Sie eine Option!',
     needRestore: 'Um diesen Ordner anzuzeigen, müssen Sie ihn aus Ihrem Papierkorb wiederherstellen',
     limitBoxTip: '1.Einige Cloud-Laufwerke weisen möglicherweise einige Einschränkungen auf. Beispielsweise unterstützt Box die Übertragung einzelner Dateien nicht, die größer als 2 GB sind. Solche Einschränkungen werden vom Cloud-Anbieter festgelegt und können von MultCloud nicht durchbrochen werden. Für mehr Information können Sie <a href="https://www.multcloud.com/de/help/limitations.html" target="_blank" class="add-cloud-link">hier klicken</a>.<br>2. Wenn Ihre Aufgaben nach dem Upgrade auf Premium immer noch keine 10 Threads erhalten haben, brechen Sie die Aufgaben ab und übertragen Sie sie erneut. Für Ihre Aufgaben werden 10 Threads mit exklusiven VIP-Servern übertragen.',
     fileNameNotEmpty: 'Der eingegebene Dateiname darf nicht leer sein.',
     notContainSpecialChar: 'Der Dateiname darf keine Sonderzeichen `/ \ | : * ? " < >` enthalten.',
     CharacterLimit:'Der Dateiname darf keine Sonderzeichen`~"# %& *: < >？ / \ { | }.`',
     pathNotExist: 'Der Pfad existiert nicht',
     emptyNotice: 'Dieser Ordner ist leer',
     trashEmpty: 'Papierkorb ist leer',
     searchEmpty: 'Suchergebnisse sind leer',
     tooManyFiles: 'Es gibt zu viele Dateien, sodass zuvor geladene Dateien nicht mehr angezeigt werden.',
     uploadSize: 'Die Gesamtgröße einer Upload-Aufgabe darf nicht größer als 1 GB sein.',
     simultaneous: 'Sie können höchstens 200 Aufgaben gleichzeitig hinzufügen.',
     cancelFailed: 'Stornierung fehlgeschlagen, die Aufgabe wird erstellt. Bitte versuchen Sie es später erneut',
     taskCanceling: 'Die Aufgabe wird storniert, bitte versuchen Sie es später erneut',
     notWith: 'Die Dateinamen und Ordnernamen dürfen nicht mit "." Beginnen oder enden.',
     notUpload: 'Upload fehlgeschlagen.',
     duplicatePhoto: 'Duplikat. Bei dem Foto, das du hochladen möchtest, handelt es sich um ein Duplikat, das noch nicht in deine Mediathek importiert wurde.',
     dataLoaded: 'Daten geladen',
     sharedDate:'Geteilte Zeit',
     failedRestore: 'Fehler beim Wiederherstellen der Datei, da das Zielverzeichnis eine Datei mit demselben Dateinamen enthält.',
     //2020-12-11 lijimin
     uploadError:'Das Herunterladen dieser Datei ist (vom offiziellen Cloud-Dienst) verboten.',
     downloadLimit: 'Das Download-Limit für heute wurde erreicht. Bitte versuchen Sie es morgen erneut.',
     //2022-4-26 wt
     newBucket:'Neuer Bucket',
     createBucket:'Der Bucket-Name sollte nur Kleinbuchstaben und Zahlen enthalten. Die Länge sollte 3-63 Zeichen betragen. PS: Der Bucket-Name sollte nicht nur aus Zahlen bestehen(z. B. „12345678“).',
     deleteBucket:'MultCloud kann keine Buckets mit einer Namenskonvention aus allen Zahlen löschen(z. B. „12345678“).',
     getBucketObjectListFail :'MultCloud kann keinen Bucket auflisten, dessen Namenskonvention nur aus Zahlen besteht.(z. B. „12345678“).',
     newAlubm: '',
     specialCharError: 'Der Dateiname darf keine Sonderzeichen `/ | : * ? " < >` enthalten.',
     copiedToClipboard: 'In die Zwischenablage kopiert',
     inputTitle: 'Titel',
     inputPlaceholder: 'Inhalt eingeben',
     pleaseInputContent: 'Bitte Inhalt eingeben',
     pleaseEnterBucketName: 'Bitte Bucket-Name eingeben',
     pleaseEnterFolderName: 'Bitte Ordnernamen eingeben',
     pleaseInputNewName: 'Bitte neuen Namen eingeben',
},
emailExploer: {
    from: 'Von',
    to: 'An',
    cc: 'Cc',
    email: 'E-Mails',
    subject: 'Thema',
    received: 'Empfangszeit',
    sentTime: 'Sendezeit',
    downloadMax200: 'Sie können höchstens 200 E-Mails gleichzeitig herunterladen.',
    noSubject: '(Kein Betreff)',
    folderName: {
        Inbox: 'Posteingang',
        Starred: 'Markiert',
        Snoozed: 'Zurückgestellt',
        Sent: 'Gesendet',
        Drafts: 'Entwürfe',
        Important: 'Wichtig',
        Chats: 'Chats',
        Scheduled: 'Geplant',
        AllMail: 'Alle E-Mails',
        Spam: 'Spam',
        Trash: 'Papierkorb',
        Unread: 'Ungelesen',
        Categories_Social: 'Kategorien_Soziale Netzwerke',
        Categories_Updates: 'Kategorien_Benachrichtigungen',
        Categories_Forums: 'Kategorien_Foren',
        Categories_Promotions: 'Kategorien_Werbung',
        Categories_Personal: 'Kategorien_Persönlich',
    }
},
imageSaver: {
    analyzing: 'Analyse läuft',
    failedToParse: 'Analyse fehlgeschlagen',
    noviceGuidance: 'Hier können Sie alle kürzlich hochgeladenen Bilder/Videos in die Cloud oder gepackte Bilder/Videos für Instagram überprüfen.',
    insDownloadExist: 'Sie haben dieses Profil bereits heruntergeladen. Sie finden es im Bereich „Aufgabenliste“.',
    taskExpiredOn: 'Abgelaufen am {time}',
    taskStoringTill: 'Speichern in {time}',
    taskPart: 'Teil',
    taskUnitFile: 'Datei',
    taskUnitFiles: 'Dateien',
    taskQueue: 'In der Warteschlange',
    taskTabUpload: 'Hochladen',
    taskTabSaveAll: 'Alles in der Cloud speichern',
    taskTabDownload: 'IG Alles Herunterladen',
    downloadInsVideo: 'Video herunterladen',
    downloadSinglePost: 'Gesamten Beitrag herunterladen',
    downloadAllPosts: 'Alle Beiträge herunterladen',
    downloadAllReels: 'Alle Reels herunterladen',
    downloadAllStories: 'Alle Stories herunterladen',
    downloadAllHighlights: 'Alle Highlights herunterladen',
    saveInsVideo: 'Video in der Cloud speichern',
    saveSinglePost: 'Gesamten Beitrag in der Cloud speichern',
    saveAllPosts: 'Alle Beiträge in der Cloud speichern',
    saveAllReels: 'Alle Reels in der Cloud speichern',
    saveAllStories: 'Alle Stories in der Cloud speichern',
    saveAllHighlights: 'Alle Highlights in der Cloud speichern',
    insCardPosts: 'Beiträge',
    insCardFollowers: 'Abonnenten',
    insCardFollowing: 'Abonniert',
    insTabPosts: 'Fotos und Videos',
    insTabReels: 'Reels',
    insTabStories: 'Stories',
    insTabHighlights: 'Highlights',
    insBlankText: 'Mit dem Instagram-Downloader von MultCloud können Sie mühelos Instagram-Beiträge, Reels, Stories und Highlights herunterladen und speichern, um Ihre Lieblingsinhalte jederzeit zu verwalten.',
    webGoogleBlankText: 'Sammeln Sie mühelos Bilder von jeder Website oder aus der Google-Suche und speichern Sie sie direkt in Ihrer Cloud oder Ihrem lokalen Speicher.',
    noTask: 'Keine Aufgaben',
    inputTipHttp: 'Geben Sie eine Website-URL oder ein Google-Suchwort ein',
    fetchBtn: 'Jetzt abrufen',
    fetchingBtn: 'Wird abgerufen...',
    loadMore: 'Mehr laden',
    downloadAll: 'Alles herunterladen',
    saveAll: 'Alles in der Cloud speichern',
    saveToCloud: 'In der Cloud speichern',
    clearHistory: 'Verlauf löschen',
    cancel: 'Abbrechen',
    retry: 'Erneut versuchen',
    view: 'Anzeigen',
    noImage: 'Kein Inhalt gefunden',
    notSupport: 'Vielleicht wird diese URL nicht unterstützt. Bitte überprüfen Sie die URL noch einmal und versuchen Sie es erneut.',
    inputTipIns: 'Geben Sie eine Instagram-URL ein',
    post: 'Beiträge',
    posts: 'Beiträge',
    uploadTo: 'Hochladen auf: ',
    download: 'Herunterladen',
    uploading: 'Hochladen',
    finished: 'Fertig',
    all: 'Alle',
    videoInputTip: 'Fügen Sie hier Ihren Videolink ein',
    videoTip: `Laden Sie hochwertige Videos von YouTube, Facebook, X und über <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1.000 anderen Websites</a>
    mit dem werbefreien, plattformübergreifenden Online-Video-Downloader von MultCloud herunter – keine Installation erforderlich.`,
    process: 'Verarbeitung...',
    thumbnail: 'Miniaturansicht',
    abrTypeVeryHigh: 'Sehr hoch',
    abrTypeHigh: 'Hoch',
    abrTypeNormal: 'Normal',
    abrTypeLow: 'Niedrig',
    default: 'Standard',
    generat: 'Datei wird erstellt',
    retryTip: 'Die Aufgabe wurde neu gestartet. Sie können den neuesten Fortschritt im Reiter „Alle“ einsehen.',
},
taskList: {
     taskListDes: 'Sie können hier Aufgaben zur Cloud-Übertragung, Cloud-Synchroniation und zum Speichern fregegebener Dateien verwalten',
     multiCloudSync: 'Multi-Cloud-Synchronisierung',
     MultiCloudTransfer: 'Multi-Clouds-Übertragung',
     nextTransfer: 'Nächste Übertragung',
     scheduled: 'Zeitplan',
     nextSync: 'Nächste Synchronisierung',
     reTransfer: 'Erneute Übertragung',
     saveNow: 'Jetzt sparen',
     transferTasks: 'Übertragungsaufgaben',
     syncTasks: 'Sync-Aufgaben',
     shareTasks: 'Freigeben',
     backupTasks: 'Sicherungsaufgaben',
     emailTransferTasks: 'E-Mail-Migrationsaufgaben',
     allTime: 'Alle Zeit',
     today: 'Heute',
     latestWeek: 'Letzte Woche',
     latestMonth: 'Letzter Monat',
     customDate: 'Benutzerdefiniertes Datum',
     allStatus: 'Alle Status',
     preset: 'Voreinstellung',
     noTaskCreated: 'Es wurde keine Aufgabe erstellt',
     createTransferTask: 'Erstellen Sie eine Übertragungsaufgabe',
     createSyncTask: 'Erstellen Sie eine Synchronisierungsaufgabe',
     createRemoteTask: 'Erstellen Sie eine Remote-Aufgabe',
     timeMustLess: 'Die Startzeit muss kleiner oder gleich wie die Endzeit sein',
     taskNameRule: 'Der Aufgabenname darf nicht länger als 200 Zeichen sein',
     backupTaskNameRule:'Der Aufgabenname darf nicht länger als 255 Zeichen sein',
     detailNote: 'Diese Aufgabe wird noch vorbereitet, es werden keine Details angezeigt.',
     notTraffic: 'Nicht genügend Datenverkehr für die Übertragung von Cloud zu Cloud',
     reSync:'Erneut synchronisieren',
     rebackup:'Erneute Sicherung',
     rerestore:'Erneut wiederherstellen',
     //2021-10-11
     createBackupTask:'Erstellen einer Sicherungsaufgabe',
     createTeamTransferTask:'Teamübertragungsaufgabe erstellen',
     multiClouds: 'Multi-Clouds',
    speedUP: 'Geschwindigkeit erhöhen',
    noTasks: 'Keine Aufgaben',
    noTasksTip: 'Klicken Sie auf die Schaltflächen unten, um eine Aufgabe zu erstellen.',
    startCloudTransfer: 'Cloud-Übertragung starten',
    startCloudSync: 'Cloud-Synchronisierung starten',
    loadingTip: 'Bitte einen Moment Geduld.',
    allTasks: 'Alle Aufgaben ({num})',
 },
 cloudTransfer: {
     transferDescription: 'Richten Sie eine Übertragungsaufgabe ein, um Dateien zwischen Cloud-Laufwerken zu übertragen',
     transferOperateFrom: 'Klicken Sie hier, um die Cloud-Laufwerke oder Ordner auszuwählen, von denen Sie übertragen möchten',
     from: 'VON',
     to: 'AN',
     transferOperateTo: 'Klicken Sie hier, um das Cloud-Laufwerk oder den Ordner auszuwählen, in den Sie übertragen möchten',
     transferNow: 'Jetzt übertragen',
     transfer: 'Übertragen',
     addTaskOnly: 'Nur Aufgabe hinzufügen',
     addTaskNow: 'Aufgabe hinzufügen und jetzt übertragen',
     addSyncTaskNow: 'Aufgabe hinzufügen und jetzt synchronisieren',
     addBackupTaskNow:'Jetzt Aufgabe und Backup hinzufügen',
     transferSucces: 'Erfolgreich übertragen',
     sureContinue: 'Sie haben mehr als 10 Quellelemente ausgewählt und jedes Quellelement entspricht einer Benachrichtigungs-E-Mail. Das bedeutet, dass Sie möglicherweise mehr als 10 Benachrichtigungs-E-Mails erhalten. Sind Sie sicher, fortzufahren?',
     sure: 'Ja, ich bin sicher.',
     //2020-10-29ljm新增
     sourceRemind:'Die maximale Anzahl von Quellelementen beträgt 200. Bitte wählen Sie weniger Elemente oder einen ganzen Ordner aus. P.S. Ein ganzer Ordner zählt nur ein Element.',
     backupSourceRemind:'Die maximale Anzahl von Quellelementen beträgt 1000. Bitte wählen Sie weniger Elemente oder einen ganzen Ordner aus. P.S. Ein ganzer Ordner zählt nur ein Element.'
 },
 cloudSync: {
     syncDescription: 'Richten Sie eine Synchronisierungsaufgabe ein, um Dateien zwischen Cloud-Laufwerken zu synchronisieren',
     syncOperateTo: 'Klicken Sie hier, um die Cloud-Laufwerke oder Ordner auszuwählen, mit denen Sie synchronisieren möchten',
     syncOperateFrom: 'Klicken Sie hier, um das Cloud-Laufwerk oder den Ordner auszuwählen, aus dem Sie die Synchronisierung durchführen möchten',
     syncNow: 'Jetzt synchronisieren',
     taskEmpty: 'Der Aufgabenname darf nicht leer sein.',
     //2020-10-29ljm新增
     aimRemind:'Die maximale Anzahl von Zielverzeichnissen beträgt 200.',
     realTimeSync:'Echtzeit-Sync',
     normalSync:'Normale-Sync',
     pause:'Pause',
     paused:'Paused',
     swicthTwoWay:'Auf Zwei-Wege-Sync umschalten',
     switchOneWay:'Auf Einweg-Sync umschalten',
     fristSync:'Erste Synchronisation',
     lastSync:'Letzte Synchronisierung',
     initSync:'Die anfängliche Synchronisation der Daten ist noch nicht abgeschlossen. Bitte warten Sie.',
     realSyncing:'Echtzeit-Synchronisation...',
     servicesSu:'Cloud-Dienste, die für die Echtzeit-Synchronisation unterstützt werden',
     addRealDrives:'Sie müssen ein Cloud-Laufwerk hinzufügen, das die Echtzeit-Synchronisation unterstützt.',
     egDrives:'Derzeit werden nur Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, Box für die Echtzeit-Synchronisation unterstützt.',
     initTial:'Initialisieren',
     realSync:'Echtzeit-Synchronisierung',
     createdAt:'Hergestellt in',
     oneWaySimple:'Einweg (einfache Synchronisation)',
     twoWay:'Zwei-Wege (Demnächst...)',
     gooleFolder:'Es wird nicht synchronisiert, wenn es nur Änderungen in Unterverzeichnissen eines Google Drive-Ordners gibt.',
     realTimeNotice:'Sie können bis zu 2 Echtzeit-Synchronisationsaufgaben gleichzeitig laufen lassen, daher werden einige Ihrer Unteraufgaben angehalten. Sind Sie sicher, dass Sie fortfahren möchten?',
     reachMax:'Sie haben die maximale Anzahl von Aufgaben erreicht, es werden nur die neuesten Aufgabe angezeigt.',
     notRun:'die Aufgabe wird nicht ausgeführt.',
     bePaused:'Wenn die Echtzeit-Synchronisationsaufgabe länger als 7 Tage nicht in Betrieb ist, wird sie automatisch pausiert.',
     dontShow:'Dies nicht mehr anzeigen',
     timeOut:'Der Traversal hat eine Zeitüberschreitung',
     outMostly:'Der Traversa liegt meist daran, dass zu viele Dateien oder Unterverzeichnisse für eine Echtzeit-Synchronisation vorhanden sind. Wir empfehlen, stattdessen eine normale Synchronisationsaufgabe zu erstellen.',
     syncPathConflict: 'Quelle und Ziel können nicht derselbe Ordner sein und dürfen sich nicht gegenseitig enthalten. Bitte wählen Sie zwei separate Ordner.',
 },
 emailTransfer: {
    cloudEmail: 'E-Mail-Migration',
    description: 'Migrieren Sie Ihre E-Mails als PDF in die Cloud.',
    migrationSetting: 'Migrationseinstellungen',
    cutSetting: 'Schnitt-Einstellungen',
    copySetting: 'Einstellungen kopieren',
    settingTips: '',
    notification: 'Benachrichtigung',
    watermark: 'Wasserzeichen',
    delWatermark: 'Entfernen Sie Wasserzeichen aus als PDF heruntergeladenen E-Mails',
    saveAtt: 'Anhänge speichern',
    converFormat: 'Gesprächsformat',
    converFormatTip: 'Zitate werden bei Aktivierung entfernt.',
    saveOnly: 'Nur die letzte Nachricht speichern',
    optionTitle: 'Es gibt bereits einige E-Mails, was würden Sie tun wollen?',
    filterTitle: 'Sie können zusätzliche Filter für die VON-Auswahl angeben.',
    filterMessage: 'Bitte geben Sie die E-Mail-Adressen ein und trennen Sie sie mit einem Komma',
    filterOption1: 'Überschreibung, wenn die Konversation aktualisiert wurde',
    filterOption2: 'Immer überspringen',
    filterOption3: 'Immer umbenennen',
    filterOption4: 'Mit Anhang',
    filterOption5: 'Ist ungelesen',
    transferNow: 'Jetzt migrieren',
    filterDateOptions1: 'Beliebiger Zeitraum',
    filterDateOptions2: 'Älter als eine Woche',
    filterDateOptions3: 'Älter als einen Monat',
    filterDateOptions4: 'Älter als 6 Monate',
    filterDateOptions5: 'Älter als ein Jahr',
    filterDateOptions6: 'Benutzerdefinierter Zeitraum',
    showMore: 'Mehr anzeigen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
},
 exception: {
     exceedMaxLimit: 'Die Anzahl der Anforderungen hat das Maximum überschritten.',
     addCloudFailed: 'Einige Parameter sind falsch eingegeben.',
     cloudNameExist: 'Dieser Anzeigename existiert bereits, bitte geben Sie einen anderen ein.',
     pathNotFound: 'überprüfen Sie, ob die Datei oder der Ordner anhand des angegebenen Pfads vorhanden ist.',
     notBeTheSame: 'Der Quellordner und der Zielordner konnten nicht identisch sein.',
     notTransferring: 'Dieses Verzeichnis kann nicht zum übertragen von Dateien ausgewählt werden. Bitte wählen Sie seine Unterverzeichnisse oder andere Verzeichnisse aus.',
     verifyCodeInvalid: 'Bestätigungscode Fehler',
     nameEmpty: 'Der Anzeigename darf nicht leer sein',
     emailEmpty: 'E-Mail darf nicht leer sein',
     serverEmpty: 'Server darf nicht leer sein',
     usernameEmpty: 'Benutzername darf nicht leer sein',
     passwordEmpty: 'Passwort darf nicht leer sein',
     domainEmpty: 'Domain darf nicht leer sein',
     BucketNameEmpty: 'Bucket Name darf nicht leer sein',
     accessKeyEmpty: 'Access Key ID darf nicht leer sein',
     secretAccessKeyEmpty: 'Secret Access Key darf nicht leer sein',
     keyIdEmpty: 'keyID darf nicht leer sein',
     applicationKeyEmpty: 'applicationKey darf nicht leer sein',
     notMediaFiles: 'Hinweis: Im Verzeichnis "Alben" können nur Albumverzeichnisse statt Mediendateien gespeichert werden.',
     notStoreDirectories: 'Das Verzeichnis "Fotos" kann keine Verzeichnisse speichern.',
     onlyStoreImages: 'Hinweis: Im Verzeichnis "Fotos" können nur Bilder, Videos und andere Mediendateien statt Verzeichnisse gespeichert werden.',
     unknownError: 'Die Verbindung zu diesem Dienst ist fehlgeschlagen. Bitte autorisieren Sie den Zugriff von MultCloud auf den Dienst erneut.',
     renameCloudFailed: 'Fehler beim Umbenennen der Cloud. Bitte versuchen Sie es später erneut.',
     deleteCloudFailed: 'Fehler beim Löschen der Cloud. Bitte versuchen Sie es später erneut.',
     invalidCloudAccount: 'Dieses Cloud-Konto existiert nicht.',
     bindEmailFail: 'E-Mail konnte nicht gebunden werden.',
     linkHasExpired: 'Der Link ist abgelaufen.',
     listItemsFailed: 'Fehler beim Auflisten der Dateien. Fügen Sie bitte die Cloud erneut zu MultCloud hinzu.',
     deleteItemFailed: 'Element konnte nicht gelöscht werden.',
     renameItemFailed: 'Element konnte nicht umbenannt werden.',
     createFolderFailed: 'Ordner konnte nicht erstellt werden.',
     moveItemFailed: 'Element konnte nicht verschoben werden.',
     shareItemFailed: 'Element konnte nicht freigegeben werden.',
     uploadFailed: 'Dateidaten nicht gefunden.',
     toFolderIdBlanked: 'Das "tid" ist ausgeblendet',
     downloadFileFailed: 'Fehler beim Herunterladen der Datei. Aktualisieren Sie bitte die Seite oder fügen Sie die Cloud erneut zu MultCloud hinzu.',
     addTaskFail: 'Aufgabe konnte nicht hinzugefügt werden.',
     taskQuotaLimit: 'Sie haben die maximale Anzahl von 1000 Cloud-zu-Cloud-Übertragungsaufgaben erreicht. Bitte löschen Sie einige unwichtige Aufgaben.',
     deleteTaskFail: 'Aufgabe konnte nicht gelöscht werden.',
     maxRunningLimit: 'Die laufende Aufgabe überschreitet die maximale Anzahl und diese Aufgabe kann als Wartend hinzugefügt werden',
     userCreateFail: 'Fehler beim Erstellen des Benutzers. Bitte versuchen Sie es später erneut.',
     userUpdateFail: 'Aktualisieren Sie die Kontoinformationen nicht. Aktualisieren Sie die Seite und versuchen Sie es erneut.',
     createSaltFail: 'Fehler beim Erstellen von Salz, bitte versuchen Sie es erneut.',
     listFolderFailed: 'Fehler beim Auflisten des Ordners, bitte versuchen Sie, die Cloud erneut hinzuzufügen.',
     cloudCategoryInvalid: 'Der Cloud-Dienst wird länger nicht mehr unterstützt.',
     executeTaskFail: 'Aufgabe konnte nicht ausgeführt werden. Bitte überprüfen Sie Ihre Webverbindung.',
     parameterInvalid: 'Die Parameter sind ungültig',
     saltInvalid: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
     emailInvalid: 'Es ist keine gültige E-Mail.',
     notAuthorized: 'Der Benutzername oder das Passwort ist nicht korrekt.',
     cloudNameEmpty: 'Der Anzeigename darf nicht leer sein.',
     addCloudExpired: 'Fehler beim Hinzufügen der Cloud, fügen Sie den Cloud-Dienst erneut hinzu.',
     verifyCodeInvalid: 'Der Bestätigungscode ist ungültig.',
     emailExist: 'Die E-Mail ist bereits vorhanden.',
     exceedMaxLimit: 'Die Anfragen überschreiten die maximale Anzahl.',
     userIdNotNull: 'Die Benutzer-ID ist null',
     notFoundTask: 'Die Aufgabe wurde nicht gefunden.',
     noTaskRunning: 'Es wird keine Aufgabe ausgeführt.',
     userNotFound: 'Der Benutzer wurde nicht gefunden.',
     loginerNotFound: 'Der Loginer wird nicht unterstützt',
     deletePermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, da Sie nicht über die „Löschen-Berechtigung” haben.',
     notHaveDeletePermission: 'Sie sind nicht berechtigt, diese Datei/diesen Ordner zu löschen.',
     uploadPermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, weil Sie keine „Hochladen-Berechtigung” haben.',
     movePermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, weil Sie keine „Erlaubnis zum Verschieben” haben.',
     copyPermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, weil Sie keine „Erlaubnis zum Kopieren” haben.',
     notHavePermission: 'Aufgrund fehlender Schreibberechtigung können Sie diese Datei/diesen Ordner nicht einfügen.',
     mkdirPermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, da Sie nicht über die „Berechtigung zum Erstellen von Ordnern” haben.',
     notCreatPermission: 'Sie können keinen Bucket oder Ordner erstellen, da die Schreibberechtigung fehlt oder nicht genügend Speicherplatz vorhanden ist.',
     renamePermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, da Sie nicht über die „Umbenennen-Berechtigung” haben.',
     creatIDriveFolderError: 'Der Objektname enthält nicht unterstützte Zeichen.',
     creatIDriveFolderToLong: 'Ordnernamen dürfen nicht länger als 245 Zeichen sein.',
     noUploadPermission: 'Aufgrund fehlender Upload-Berechtigungen oder unzureichendem Cloud-Speicherplatz können Sie diese Datei nicht hochladen.',
     bucketNameLongError: ' Bucket-Namen müssen 3 bis 63 Zeichen lang sein, dürfen nur Kleinbuchstaben, Zahlen, Punkte (.) und Bindestriche (-) verwenden, mit Buchstaben oder Zahlen beginnen und enden und aufeinanderfolgende Punkte vermeiden.',
     bucketNameIsNotIp: 'Der Bucket-Name darf keine IP-Adresse sein.',
     downloadPermissionLimited:'Sie können mit diesem Vorgang nicht fortfahren, da Sie keine „Herunterladen-Berechtigung” haben.',
     ipNotFound: 'Die IP wurde nicht gefunden',
     sugarSyncWarn: 'Es wird nicht unterstützt, das Verzeichnis auszuwählen. Bitte wählen Sie das Verzeichnis "Webarchiv", "Magic Briefcase", "Mobile Fotos", seine Unterordner oder andere Verzeichnisse aus.',
     flickWarn: 'Es wird nicht unterstützt das Verzeichnis auszuwählen. Bitte wählen Sie das Verzeichnis "/Alben", seine Unterordner oder andere Verzeichnisse.',
     baiDuWarn: 'Es wird nicht unterstützt das Verzeichnis auszuwählen. Bitte wählen Sie das Verzeichnis "全部文件/我的应用数据/MultCloud", Unterordner oder andere Verzeichnisse aus.',
     dropBoxbusinessWarn: 'Es wird nicht unterstützt, das Stammverzeichnis auszuwählen, bitte wählen Sie die anderen Verzeichnisse aus.',
     onlyAlbum: 'Nur von MultCloud erstellte oder freigegebene Albumverzeichnisse können ausgewält werden, um Bilder, Videos und andere Mediendateien zu speichern.',
     createFolderFail: 'Fehler beim Erstellen des Ordners',
     parametersNotEmpty: 'Die Parameter sollten nicht leer sein',
     //mega报错
     addMegaFailed: 'Einige Parameter sind nicht korrekt eingegeben oder Sie haben F2A aktiviert.',
     //mySql报错
     mySqlWarn:'Diese Cloud kann nicht als Ziel der Cloud-zu-Cloud-Übertragung ausgewählt werden.',
     //2020-10-29ljm新增
     maxTaskRemind:'Sie haben die maximale Anzahl von 5000 Cloud-Übertragungs-/Synchronisierungsaufgaben erreicht. Bitte löschen Sie einige unnötige Aufgaben und versuchen Sie es erneut. P.S. Wenn eine Übertragungsaufgabe 3 Quellen enthält, zählt die Übertragungsaufgabe als 3 Aufgaben.',
     // 2020-11-25 yjs
     torrentTort:'Dieser Inhalt ist nicht autorisiert oder verletzend kopiert.',
     //2020-12-4 xth
     shareNotUpload:'Der Eigentümer hat die Berechtigung „Hochladen zulassen“ abgebrochen. Bitte aktualisieren Sie die Seite.',
     //2020-12-9 xth
     shareItemUpdate:'Der Eigentümer hat die Berechtigung für diesen Freigabelink geändert. Bitte aktualisieren Sie die Seite.',
     nameLong:'Der Benutzername ist zu lang (max. 20 Zeichen) Ihr Benutzername hat eine Länge von 20 Zeichen.',
     notPermission:'Dies ist eine Teamdatei, und Sie haben keine Berechtigung, diesen Vorgang auszuführen.',
     notOpened:'Diese Cloud unterstützt keine Echtzeit-Synchronisation.',
     taskNotFound:'Die Aufgabe existiert nicht.',
     subscribeFail:'Die Aufgabe konnte nicht erstellt werden.',
     driveAccountIdInvalid:'Die Echtzeit-Synchronisierungsaufgabe kann nicht erstellt werden. Die ausgewählte Cloud muss entfernt und erneut hinzugefügt werden, und versuchen Sie es erneut.',
     unknownState:'Dieser Vorgang kann nicht ausgeführt werden, versuchen Sie es später erneut.',
     InvalidParameter:'Ungültiger Parameter.',
     InvalidDirectory:'Das Stammverzeichnis der Box unterstützt diese Funktion nicht.',
     HasExist:'Die Sofortsynchronisierungsaufgabe für diesen Ordner existiert bereits, bitte brechen Sie die Sofortsynchronisierungsaufgabe für diesen Ordner ab und erstellen Sie sie im Ordner neu.',
    //  taskRunningNumberLimited:'Sie können 5 Cloud-zu-Cloud-Aufgaben parallel ausführen, bitte brechen Sie eine laufende Aufgabe ab und versuchen Sie es erneut.',
     taskRunningNumberLimited:'Il y a déjà 2 tâches de synchronisation en temps réel en cours d\'exécution et veuillez d\'abord suspendre une tâche de synchronisation en temps réel.',
     reachedLimit:'Sie haben das Ratenlimit dieser Cloud erreicht, bitte versuchen Sie es später noch einmal.',
     selectAlbumWarn:'Hinweis: Ein Albumverzeichnis kann nur Bilder, Videos und andere Mediendateien speichern, aber keine Verzeichnisse.',
     notSupported:'Die Echtzeit-Synchronisation wird für Multi-Ziel-Tasks derzeit nicht unterstützt.',
     incorrectFormat:'Ihr Telefonnummernformat ist leider falsch format',
     taskMaximumNumberLimited:'Sie haben die maximale Anzahl von 200 Echtzeit-Synchronisierungsaufgaben erreicht. Bitte löschen Sie einige unnötige Echtzeit-Synchronisierungsaufgaben und versuchen Sie es erneut.',
     autoLoginFail: 'Sie haben die zweistufige Verifizierung aktiviert, bitte melden Sie sich erneut an.',
     unsubscribeFail:'abmelden fehlgeschlagen',
     //云盘操作报错
     alreadyAdd:'Sie haben das Cloud-Laufwerk bereits hinzugefügt.',
     toggleWhileEditing:'Das hinzugefügte Konto stimmt nicht mit dem aktuellen Konto überein.',
     //2022-4-25 wt
     emptyBucket:'Sie können keine Buckets löschen, die nicht leer sind. PS: Bitte vergewissern Sie sich, dass sich auch keine Objekte in der Bucket-Versionierung von Wasabi befinden.',
     cannotCopyFolder:'Sie können einen Ordner nicht in denselben Bucket kopieren.',
     cannotCopyIdrivee2Folder: 'Ordner unter demselben Idrive e2-Konto können nicht untereinander kopiert werden.',
     cannotCutFolder:'Ordner unter demselben Bucket können nicht einander ausgeschnitten und eingefügt werden.',
     bucketAlreadyExists:'Der angeforderte Bucket-Name ist nicht verfügbar. Der Bucket-Namensraum wird von allen Benutzern des Systems gemeinsam genutzt. Bitte wählen Sie einen anderen Namen und versuchen Sie es erneut.',
     accessPermissionLimited:'Sie haben keine Zugriffsberechtigung für diesen Ordner.',
     accessDenied:'Zugriff verweigert, Sie sind nicht berechtigt, diesen Vorgang durchzuführen.',
     shareTransferCanotCopy: 'Das Kopieren des Stammordners einer Freigabe mit mehreren Elementen wird derzeit nicht unterstützt.',
     // 2022-6-8 wt
     sharePointOnlineNotTrans:'Das SharePoint-Stammverzeichnis kann nicht für die Übertragung von Dateien ausgewählt werden, bitte wählen Sie ein Unterverzeichnis einer Site.',
     sharePointListFailed : 'Fehler 500: InternalServerError. Hinweise: Bitte prüfen Sie, ob dieses Konto Zugriff auf den SharePoint-Dienst hat.',
     sameDirError: 'Die Quellkonten und die Zielkonten können nicht identisch sein.',

     accessDenied:'Zugriff verweigert',
     //iCloudPhotos报错
    onlySaveAlbums: 'Hinweis: In dem von Ihnen gewählten Zielverzeichnis können nur Alben (Ordner) gespeichert werden.',
    notSelectICloudPhotosRoot: 'Hinweis: Im Stammverzeichnis von iCloud Fotos können nur Alben (Ordner) gespeichert werden.',
    notSelectICloudPhotosForder: 'Hinweis: In dem von Ihnen gewählten Zielverzeichnis können nur Alben (Ordner) gespeichert werden.',
    notSelectICloudPhotosAlbum: 'Hinweis: Das von Ihnen gewählte Zielverzeichnis kann nur Bilder speichern (Ordner nicht verfügbar).',
    notSelectICloudPhotosOther: 'Hinweis: Das von Ihnen gewählte Zielverzeichnis kann Bilder nicht direkt speichern, alle übertragenen Bilder werden im Ordner „Zuletzt“ gespeichert.',
    notSelectICloudPhotosBackup: 'iCloud-Fotos können nicht als Ziel für „Cloud-Backup“ ausgewählt werden. Um Bilder in iCloud-Fotos zu speichern, wählen Sie bitte „Cloud-Übertragung“ oder „Cloud-Synchronisierung“.',
    notSelectICloudPhotosSyncRoot: 'Hinweis: Bilder können nicht mit dem Stammverzeichnis von iCloud-Fotos synchronisiert werden.',
    notSelectICloudPhotosSync: 'Dies ist ein Ordner in iCloud-Fotos, Sie können Bilder nur mit Alben in iCloud-Fotos synchronisieren.',
    sendTooMany: 'Es wurden zu viele Verifizierungscodes gesendet. Geben Sie den letzten Code ein, den Sie erhalten haben, verwenden Sie eines Ihrer Geräte oder versuchen Sie es später erneut.',
    verifySecurityCodeFailed: 'Verifizierung fehlgeschlagen, bitte überprüfen Sie den Verifizierungscode und geben Sie ihn erneut ein.',
    appleNotEnablePhotos: 'iCloud Fotos ist für deine Apple-ID nicht verfügbar. Melde dich mit einer Apple-ID an, die du mit einem Apple-Gerät verwendest, um iCloud Fotos zu verwenden.',
    tooManyRequests429: 'Ser-Raten-Limit überschritten. Versuchen Sie es erneut nach {date}',
    tooManyRequests403: 'Zu viele Anfragen gleichzeitig, bitte versuchen Sie es später erneut.',
    // iCloudDrive报错
    folderNameIsTooLong: 'Der Ordnername darf nicht länger als 255 Zeichen sein.',
    fileNameIsTooLong: 'Der Dateiname darf nicht länger als 250 Zeichen sein.',
    iCloudDriveNotEnoughSpace: 'Not enough space to upload the file.',
    uploadFileIsTooBig: 'Die Datei ist zu groß zum Hochladen. MultCloud begrenzt derzeit Uploads auf maximal 100 MB.',
    uploudFileSizeIsZero: 'Es ist nicht möglich, Null-Byte-Dateien auf iCloud Drive hochzuladen.',
    notUploudSpecialFile: 'Dieser Dateityp kann nicht in diesen App-Ordner hochgeladen werden.',
    notRenameApp: 'Apple erlaubt es nicht, die App-Ordner umzubenennen, z. B. Pages, Numbers und Keynote.',
    ErrorDeleteDistinguishedFolder: 'Distinguished-Ordner können nicht gelöscht werden.',
    moreThan256Characters: 'Der Ordnername darf 256 Zeichen nicht überschreiten.',
    cloudNotFound: 'Die Cloud wurde entfernt.',
    fourSharedUnauthorized:'Ihre 4shared-Autorisierung ist abgelaufen. Bitte autorisieren Sie Ihr Konto erneut, indem Sie auf "Wieder hinzufügen" klicken.',
    fileFolderNameLengthExceed:"Datei-/Ordnernamen dürfen nicht länger als 255 Zeichen sein.",
    invalidLink: 'Ungültiger Link.',
    requestFailed: 'Anforderung fehlgeschlagen.',
    exceeds2GB: 'Dateigröße überschreitet 2 GB und kann nicht heruntergeladen werden.',
    licenseUpgradError: 'Die Lizenz ist nicht verfügbar, da Sie {scheme}-Abonnent sind',
    noLicenseCode: 'Bitte geben Sie einen Lizenzcode ein',
    licenseCodeError: 'Der eingegebene Lizenzcode ist falsch',
 },
 preview: {
     fileNotReview: 'Dateien können nicht überprüft werden',
     goOringinalSite: 'Gehe zur Original Site'
 },
 remoteTask: {
     remoteTask: 'Remote-Aufgabe',
     createTask: 'Aufgabe erstellen',
     successsExceed: 'Link kopiert!',
     operateSuccess: 'Erfolg betreiben',
     noRemote: 'Es wurde keine Remote-Aufgabe erstellt',
     unKnownError: 'Unbekannter Fehler',
     undefinedDisk:"Sie können das Zielverzeichnis nicht finden. Kopieren Sie zuerst den Link der Aufgabe und erstellen Sie dann erneut eine Offline-Aufgabe.",
     taskExpired:'Die Aufgabe ist abgelaufen. Bitte erstellen Sie die Aufgabe neu.',
     createDescribe:'Übertragen Sie Dateien von Links, Torrents, Magneten direkt in Ihre Clouds',
     saveURLDescribe:'Speichern Sie Dateien von URL-Links direkt in Ihre Clouds.',
     excuteNow:'Jetzt ausführen',
     noSeeds:'Geringe Ressource',
     failedToParse:'Fehler beim Analysieren.',
     parseMagnetRunning:'Samen analysieren, bitte warten......',
     selectedFileLimit:'Die Gesamtzahl der ausgewählten Dateien darf 500 oder 50G nicht überschreiten',
     addLink: 'Link hinzufügen',
    startEmailSend: 'E-Mail-Benachrichtigung nach Abschluss der Aufgabe senden',
    nowUpload: 'Jetzt hochladen',
 },
 shares: {
     myShares: 'Meine Freigaben',
     savedShares: 'Gespeicherte Freigaben',
     sharedOn: 'Geteilt am',
     allowedTo: 'Upload zulassen',
     location: 'Ort',
     shareNull: 'Sie haben noch keine Datei freigegeben.',
     shareNullTips: 'Tipps: Um eine Datei zu teilen, klicken Sie einfach mit der rechten Maustaste auf die Datei und wählen Sie die Option „Teilen“.',
     savedShareNull: 'Sie haben noch keine freigegebene Datei gespeichert.',
     savedShareNullTips: 'Tipps: Wenn jemand einen freigegebenen Link mit Ihnen teilt, können Sie ihn hier für den schnellen Zugriff speichern.',
 },
 login: {
     experienceSigning: 'Erfahrung ohne Registrierung',
     forgotPassword: 'Passwort vergessen?',
     signIn: 'Anmelden',
     rememberMe: 'Angemeldet bleiben',
     keepLogin: 'Angemeldet bleiben',
     loginWith: 'Login mit',
     email: 'E-Mail',
     password: 'Passwort',
     verificationCode: 'Bestätigungscode',
     firstName: 'Vorname',
     lastName: 'Nachname',
     confirmPassword: 'Passwort bestätigen',
     createAccount: 'Konto erstellen',
     continueWith: ' oder weiter mit',
     resetMessage: 'Nachricht senden',
     enterEmail: 'Geben Sie unten die E-Mail-Adresse ein, mit der Sie sich angemeldet haben. Es wird eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts gesendet.',
     enterCorrectEmai: 'Bitte geben Sie das korrekte Format der E-Mail-Adresse ein.',
     passwordCharacters: 'Ihr Passwort muss 8-16 Zeichen lang sein.',
     passwordDiff: 'Die beiden eingegebenen Passwörter sind inkonsistent',
     enterCode: 'Bitte geben Sie den Bestätigungscode ein.',
     sentSuccess: 'Die E-Mail wurde erfolgreich gesendet.',
     successfully: 'Erfolgreich registrieren',
     pleaseEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
     pleasePassword: 'Bitte geben Sie Ihr Passwort ein',
     accountActivated: 'Ihr Konto wurde nicht aktiviert.',
     enterCorrectPass: 'Bitte geben Sie die richtige E-Mail-Adresse oder den Namen und das Passwort des temporären Kontos ein.',
     resetPasseord: 'Um Ihr Konto zu schützen, klicken Sie bitte auf "Passwort vergessen", um Ihr Passwort zurückzusetzen.',
     validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
     enterFirstName: 'Bitte geben Sie Ihren Vornamen ein.',
     enterLastName: 'Bitte geben Sie Ihren Nachnamen ein.',
     reEnterPass: 'Bitte geben Sie Ihr Passwort erneut ein.',
     creatingAccount: 'Zur Erstellung eines Kontos stimmen Sie',
     termsUse: 'den Nutzungsbedingungen',
     privacyPolicy: 'die Datenshutz zu',
     thankYou: 'Danke!',
     checkEmail: 'Bitte überprüfen Sie Ihre E-Mail',
     confirmRegistration: ', um Ihre Registrierung zu bestätigen. Sie können den Aktivierungsprozess überspringen und unser Produkt normal verwenden. Wenn Sie jedoch Ihr Passwort vergessen haben, können wir Ihnen nicht helfen, es wiederherzustellen.',
     noteReceiveEmail: 'Keine E-Mail erhalten?',
     receiveConfirmationEmail: 'Wenn Sie keine Bestätigungs-E-Mail erhalten haben, senden Sie uns bitte eine E-Mail an',
     buttonResend: 'oder klicken Sie auf die Schaltfläche zum erneuten Senden.',
     forgetEmail: 'Vergessen Sie Ihre E-Mail-Adresse?',
     sendEmailSupport: ' Senden Sie eine E-Mail an den Support',
     trackDown: 'und wir werden es verfolgen.',
     passwordnotMatch: 'Das eingegebene Passwort stimmt nicht überein',
     enterVaildPassWord: 'Bitte geben Sie ein gültiges Passwort ein',
     usernameNotContain: 'Der Benutzername darf keine Sonderzeichen enthalten.',
     updatedSuccessfully: 'Ihre Daten wurden erfolgreich aktualisiert',
     thankBindEmail: 'Vielen Dank für die verbindliche E-Mail-Adresse, bitte überprüfen Sie die Aktivierungs-E-Mail rechtzeitig',
     failExceedOperation: 'Diese Operation kann nicht überschritten werden',
     enterNewPassword: 'Bitte geben Sie das neue Passwort ein',
     confirmationPassword: 'Bitte geben Sie das Bestätigungskennwort ein',
     userNameNot: 'Benutzername darf nicht leer sein',
     //login popup用
     signUp: 'Registrieren',
     logInButton: 'Einloggen',
     logInWith: 'Einloggen mit',
     logToMultCloud: 'Sich bei MultCloud einloggen',
     logEmailInput: 'E-Mail/Temporärer Kontoname',
     verificationIncorrect: 'Die von Ihnen eingegebene Bestätigung ist falsch.',
     signUpTitle: 'Registrieren Sie sich und erhalten Sie jeden Monat 5 GB kostenlosen Datenvolumen',
     title: "Übertragen Sie sie mit MultCloud auf Ihre Cloud-Dienste",
     tips: "Sie haben bereits ein Konto?",
     tips2: "Haben Sie noch kein Konto?",
     btnTxt: "Anmelden ...",
     facebook: "Facebook",
     google: "Google",
     exception: {
         strEmpty: "Bitte füllen Sie dieses Feld aus.",
         nameToLong: "Ihr Benutzername muss aus 1-20 Zeichen bestehen.",
         emailError: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
         pwdError: "Bitte geben Sie ein Passwort mit 8-16 Zeichen ein.",
         rePsdEmpty: "Bitte geben Sie Ihr Passwort erneut ein.",
         rePwdError: "Passwort stimmt nicht überein.",
         codeEmpty: "Bitte geben Sie den Bestätigungscode ein.",
         codeError: "Der Bestätigungscode muss aus 4 Zeichen bestehen.",
         verifyCodeInvalid: "Bestätigungscode ist nicht korrekt.",
         emailExist: "Die E-Mail-Adresse wurde bereits registriert.",
         emailPsdError: "Der Name oder das Passwort des E-Mail-/temporären Kontos ist nicht korrekt.",
     }
 },
 home: {
     driveNameNotContain: 'Der Laufwerksname darf keine Sonderzeichen `/ \ | : * ? " < >  &` enthalten.',
     cloudDiskName: 'Der Name der Cloud-Laufwerke darf nicht länger als 200 Zeichen sein.'

 },
 sharesPage: {
     linkFailure: 'Entschudigung, diese freigegebene Datei wurde abgebrochen.',
     linkMasking: 'Entschuldigung, diese freigegebene Datei wurde für die Anzeige gesperrt.',
     saveCloud: 'In Cloud speichern',
     directDownload: 'Direkt herunterladen',
     saveLink: 'Link speichern',
     cancelShare:'Freigabe abbrechen',
     uploadFile: 'Datei hochladen',
     newFolder: 'Neuer Ordner',
     saveLinkSuccessBefore: 'Sie haben den Link erfolgreich gespeichert.',
     saveLinkSuccessAfter: ' Gespeicherte Links anzeigen',
     saveLinkFail: 'Der Link konnte nicht gespeichert werden.',
     downloadingFolder: 'Das Herunterladen von Ordnern wird derzeit nicht unterstützt.',
     downloadingMore: 'Sie können jeweils nur eine Datei herunterladen.',
     downloadingNone: 'Bitte wählen Sie eine Datei aus.',
     sharecanceledSuccess: 'Freigabe abgebrochen.',
     sharecanceledFailed: 'Freigabe konnte nicht abgebrochen werden.',
     newFolderInRoot: 'Bitte geben Sie Unterverzeichnisse ein, um einen neuen Ordner zu erstellen.',
     uploadFileInRoot: 'Bitte geben Sie Unterverzeichnisse ein, um eine Datei hochzuladen.',
     selectFileTransfer: 'Bitte wählen Sie eine zu übertragende Datei aus.',
     createTransferFailed: 'Übertragungsaufgabe konnte nicht erstellt werden.',
     createTransferSuccessBefore: 'Sie haben erfolgreich eine Übertragungsaufgabe erstellt.',
     createTransferSuccessAfter: '  Aufgabe anzeigen',
     addCloudService: 'Cloud-Dienst hinzufügen',
     mustAddClouds: 'Sie müssen ein gültiges Cloud-Laufwerk hinzufügen.',
     selectSaveCloudTitle: 'Bitte auswählen',
     moreClouds:'Mehr Clouds',
     saveLinkExists: 'Der Link existiert bereits.',
     errorShare404: 'Quelldatei nicht gefunden.',
     passWordError: 'Falsches Passwort!',
     passWordNone: 'Das Passwort sollte nicht leer sein.',
     passWordInputTitle: 'Private MultCloud-Freigabedatei',
     passWordInputMsg: 'Bitte geben Sie das Passwort ein.',
     passWordInputButton: 'OK',
     loginErrorMax: 'Sie haben Ihr Passwort schon lange nicht mehr aktualisiert. Bitte aktualisieren Sie Ihr Passwort.',
     uploadFolder: 'Sie können derzeit nur Dateien hochladen.',
     pleaseSignIn: 'Bitte melden Sie sich bei MultCloud an.',
 },
 share:{
     noManageMyShare: "Hier können Sie alle freigegebenen Dateien verwalten.",
     noManageSavedShare: "Hier können Sie alle gespeicherten Freigaben verwalten.",
     unknownError: "Die Freigabedatei fehlt, sie kann verschoben oder gelöscht werden.",
     privateShareText: "(Bitte kontaktieren Sie mich, um das Passwort zu erhalten)",
 },
 inviteFriends:{
     titleBefor: 'aden Sie so viele Freunde wie möglich ein und erhalten Sie ',
     titleAfter: ' Datenvolumen für jeden eingeladenen Freund! Keine Quotenbegrenzung!',
     shareEmailTitle: 'Einladung teilen: ',
     shareLinkTitle: 'Einladungslink teilen: ',
     emailSend: 'Senden',
     emailTip: 'Hier E-Mail-Adresse hinzufügen',
     wonMonthFlows: 'Lebenslanges zusätzliches Datenvolumen, das Sie in diesem Monat gewonnen haben: ',
     wonMonthTitle: 'Holen Sie sich die Chance, LEBENSLANGES UNBEGRENZTES Datenvolumen zu gewinnen!',
     lastWinner: 'Letzter Gewinner ',
     winnerInvites: 'Mit {num} Einladungen',
     winnerTip: 'LEBENSLANG UNBEGRENZT gewonnen',
     statusTitle: 'Ihr Freigabestatus',
     successInvites: 'Erfolgreiche Einladungen in diesem Monat: ',
     chanceWin: 'Gewinnchance: ',
     tipsTitle: 'Bedingungen',
     tipsOne: 'Nur eingeladene Benutzer mit einer verifizierten E-Mail-Adresse zählen als erfolgreiche Einladung.',
     tipsTwo: 'Keine Quotenbeschränkung für das Datenvolumen, das Sie durch das Einladen von Personen verdienen.',
     tipsThird: 'Wenn Sie bereits Abonnent mit unbegrenztem Datenvolumen sind, können Sie keine 2GB durch erfolgreiche Einladung gewinnen, aber Ihre Chance, den Lebenslangen Unbegrenzten Dienst zu gewinnen, wird verdoppelt.',
     shareText: 'MultCloud - Übertragen und verwalten Sie mehrere Cloud-Dateien mit einer App. Treten Sie MultCloud heute bei und erhalten Sie den Bonus mit 2 GB Cloud-to-Cloud-Datenvolumen!',
 },
 paySystem:{
     billed:'Abgerechnet mit 0,099 €/GB für zusätzliches Datenvolumen',
     subCould:'Abonnenten könnten 50 GB/5,9 € und 100 GB/9,9 € für zusätzliches Datenvolumen verwenden, wenn das Datenvolumen nicht ausreicht',
     limitedMonth:'150 GB/Monat',
     limitedTrafficMonth:'150GB Verkehr/Monat',
     unlimitedTraffic:'Unbegrenztes Datenvolumen für die Lebensdauer!',
     foraYear:'Unbegrenztes Datenvolumen für ein Jahr',
     noNeedPurchase:'Es braucht kein zusätzliches Datenvolumen zu kaufen',
     yearlyPayment:'Jährliche Zahlung (7,5 €/Monat)',
     validityData:'Die Gültigkeit des von Ihnen gekauften Datenvolumens ist dauerhaft',
     additionalPackage:'Zusätzliches Volumenpaket',
     subscriptmc:'Ihr Abonnement von MultCloud',
     upgradeMore:'Upgrade auf MultCloud Premium für mehr Übertragungsvolumen und zusätzliche Vorteile',
     recommended:'Empfohlen',
     toUnlimited:'Upgrade auf Unbegrenzt',
     otherPlan:'Andere Pläne',
     moreTraffic:'Datenvolumen Kaufen',
     monthlySubscriber:`Sie sind ein monatlicher Abonnent und haben 150 GB Datenvolumen, um jeden Monat Daten zwischen Cloud-Speicherdiensten zu übertragen oder zu synchronisieren.`,
     moreDetails:`<a class='add-cloud-link sysLink'>Weitere Details zu den Privilegien >></a>`,
     dataTraffic:'Nutzung des Datenvolumens im aktuellen Monat',
     cloudTraffic:'Cloud-to-Cloud-Datenvolumen',
     buyNow:'Jetzt kaufen',
     specialOffer:'Sonderangebot',
     lifetimeFree:'Lebenslang Kostenlos',
     unsubscribe:'Abbestellen',
     includes:'Beinhaltet',
     reSubscription:'Abonnement reaktivieren',
     monthTraffic:'Unbegrenztes Datenvolumen für einen Monat',
     threeMonth:'30 GB/Monat',
     monthlyPayment:'Monatliche Zahlung',
     monthlyUnlimited:'Monatlich Unbegrenzt',
     gb:'GB',
     YearlyUnlimited:'Jährlich Unbegrenzt',
     YearlyPaymentNine:'Jährliche Zahlung (9,9 €/Monat)',
     Onetime:'Einmalige Zahlung',
     twoMonthree:'200 GB/Monat x3',
     QuarterlyPayment:'Vierteljährliche Zahlung (8,3€/Monat)',
     fourMOne:'400 GB/Monat x12',
     quarterlySubscriber:`Sie sind ein vierteljährlicher Abonnent und haben 200 GB Datenverkehr, um jeden Monat Daten zwischen Cloud-Speicherdiensten zu übertragen oder zu synchronisieren.`,
     yearlySubscriber:`Sie sind ein jährlicher Abonnent und haben 400 GB Datenverkehr, um jeden Monat Daten zwischen Cloud-Speicherdiensten zu übertragen oder zu synchronisieren.`,
     expireIn:'Verfallen in',
     billYearly:'Jährlich abgerechnet',
     billMonthly:'Monatlich abgerechnet',
     billQuarterly:'Abgerechnet vierteljährlich',
     twoMonTrafficthree:'200GB Verkehr/Monat x3',
     fourMTrafficOne:'400GB Verkehr/Monat x12',
     deleteSubAccount:'Sie müssen sich abmelden, um Ihr Konto zu löschen. Sind Sie sicher, dass Sie dies tun?',
     payFirst:'Sie müssen zuerst ',
     paybindEmail:`<a class='add-cloud-link sysLink'>Ihre E-Mail Adresse bestätigen </a>`,
     payEnd:'bevor Sie erfolgreich abonnieren können, denn wir müssen sicherstellen, dass Sie die E-Mail über Ihr Abonnement erhalten haben.',
     yearlyPaymentTxt:'Jährliche Zahlung',
     quarterlyPaymentTxt:'Vierteljährliche Zahlung',
     //2021-5-20新加
     //1
     upUnlimited:'Upgrade auf Jährlich Unbegrenzt',
     //2
     payDiff:'Zahlen Sie nur den Preisunterschied!',
     //3
     yearlyUnlimit:'MultCloud (<b>Jährlich Unbegrenzt</b>)',
     //4
     providesUnlimited:'Jährlich Unbegrenzter Plan bietet unbegrenztes Datenvolumen für die Übertragung oder Synchronisierung von Daten zwischen Cloud-Speicherdiensten für 12 Monate.',
     //5
     subProduct:'Dies ist ein Abonnementprodukt mit einer Gebühr von',
     perYear:'pro Jahr.',
     cancelSubscription:'Sie können Ihr Abonnement jederzeit kündigen.',
     //6
     defaultPayment:'Die Standardzahlungsmethode ist',
     //7
     anotherPayment:'Wenn Sie eine andere Zahlungsmethode verwenden möchten,',
     clickHere:'klicken Sie bitte hier',
     //8
     tryAgain:'Die Zahlung kann vorerst nicht erfolgen. Bitte überprüfen Sie Ihre Zahlungsmethode und versuchen Sie es erneut.',
     //9
     contactPayment:'Haben Sie ein Problem mit der Zahlung? Bitte wenden Sie sich an <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
     //10
     Notice:'Hinweis',
     beforeBind:'Bitte binden Sie Ihre E-Mail-Adresse vor dem Abonnieren.',
     processorder:'Auftrag verarbeiten',
     eachGbMoney:'0,12€/',
     eachGbMoneyT:'0,10€/',
     payCouponQuartly:'Vierteljährliche Zahlung(6.63€/Monat)',
     payCouponlimitedYearly:'Jährliche Zahlung(5.83€/Monat)',
     payCouponunlimitedYearly:'Jährliche Zahlung(7.50€/Monat)',
     payCouponunlimitedYearlyLow:'Jährliche Zahlung(6.67€/Monat)',
     tips:'Hinweis: Wenn Sie Fragen haben, wenden Sie sich bitte an <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
     monthly:'Monatlich 150 GB',
     //新版付费页面
     payTitle: 'Wählen Sie die richtige MultCloud für Sie!',
     limitedData: 'Begrenzte Daten',
     unlimitedData: 'Unbegrenzte Daten',
     monthly: 'Monatlich',
     annually: 'Jährlich',
     save58: 'Bis zu 58% sparen',
     payTip: 'Kontakt zu unserem Vertriebsteam',
     limitTips: 'Ungenutztes Datenvolumen wird sich ansammeln',
     unlimitTips: 'Keine Sorgen mehr um Datenlimits',
     tips2: 'Sollten Sie während des Online-Kaufs auf Probleme stoßen, können Sie uns gerne kontaktieren: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: 'Dies ist das Angebot für Benutzer des {type}-Tarifs.',
    tabPayScheme: {
         perMonth: 'Monatliche Zahlung',
         perYear: 'Jährliche Zahlung',
         perNextYear: 'für das erste Jahr (verlängert sich zu {price})',
         refundDays: 'Tage Geld-zurück-Garantie',
         advanced: 'Erweiterte Funktionen',
         payPremium: 'Erwerben Sie ein Upgrade auf einen beliebigen Premium-Plan und genießen Sie alle folgenden erweiterten Funktionen',
         payUnlimited: 'Erwerben Sie ein Upgrade auf einen beliebigen UNLIMITED-Tarif und genießen Sie alle folgenden erweiterten Funktionen',
         freeTip1: 'Mehr Cloud-to-Cloud-Datenvolumen',
         freeTip2: 'UNBEGRENZTER Cloud-to-Cloud-Datenvolumen',
         freeTip3: 'Geplante Übertragung/Synchronisation/Backup',
         freeTip4: 'Doppelte Sync',
         freeTip5: '10 Übertragungsfäden',
         freeTip6: '8 Sync-Modi',
         freeTip7: 'Datei-Filter',
         freeTip8: 'VIP-Übertragungsserver',
         freeTip9: 'VIP-Kundenbetreuung',
         freeTip10: '5 Cloud-zu-Cloud-Aufgaben parallel',
         freeTip11: 'Unbegrenzte E-Mail-Konversionen',
         freeTipTitle1: 'Abonnenten können 2 Echtzeit-Synchronisierungsaufgaben und 2 normale Synchronisierungsaufgaben haben (insgesamt 4).',
         freeTipTitle2: 'Es gibt 10 Übertragungsfäden für Abonnenten und 2 Übertragungsfäden für kostenlose Nutzer.',
         freeTipTitle3: 'Zwei-Wege-Synchronisation und 7 benutzerdefinierte Optionen für die Einweg-Synchronisation, Spiegel-Synchronisation unterstützt.',
         freeTipTitle4: 'Richten Sie einen Filter ein, um Dateien mit benutzerdefinierten Dateinamen oder bestimmten Erweiterungen automatisch zu übertragen oder zu synchronisieren.',
         freeTipTitle5: 'Abonnenten können 5 Cloud-zu-Cloud-Aufgaben parallel ausführen, während kostenlose Nutzer jeweils nur 1 Aufgabe ausführen können.',
         freeTipTitle6: 'Abonnenten können eine unbegrenzte Anzahl von E-Mails in PDFs umwandeln, während kostenlose Benutzer auf die Konvertierung von 50 E-Mails pro Monat beschränkt sind.',
     },
     nowPayScheme: {
        clearInsCountText: 'Aber das ungenutzte Download-Kontingent für Instagram-Profile wird gelöscht.',
        manageYourPlan: 'Verwalten Sie Ihr Abonnement',
        price: 'Preis',
        paymentMethon: 'Zahlungsmethode',
        autoRenewal: 'Automatische Verlängerung',
         priceVat: 'Enthält {currency}{vatPrice} Mehrwertsteuer ({percent} auf {currency}{netPrice}).',
         defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
         paypalPayment: 'Die Standard-Zahlungsmethode ist PayPal.',
         changePayment: 'Zahlungsmethode ändern',
         activated: 'Nächstes Abrechnungsdatum {time}',
         deactivated: 'Nächstes Abrechnungsdatum {time}',
         appleTip: 'Ihre aktuellen {name} wurden im Apple Store gekauft.',
        appleTipId: 'Apple Transaktions-ID: {id}.',
        googleTip: 'Ihre aktuellen {name} wurden in Google Play gekauft.',
        googleTipId: 'de commande Google Play : {id}',
        appNextTimeTip: 'Die automatische Erneuerung ist aktiviert. Nächstes Abrechnungsdatum ist der {time}.',
        appNoSubscribe: 'Die automatische Erneuerung ist deaktiviert.',
     },
     // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Ups! Unzureichender Cloud-zu-Cloud-Datenverkehr',
        title_ins: 'Sie haben das Download-Limit erreicht',
        title_pdf: 'Sie haben das Limit für die E-Mail-zu-PDF-Konvertierung erreicht',
        title_modes: 'Der Modus ist nur in Premium-Plänen',
        title_remote: 'Sie haben das Limit für den Remote-Upload erreicht',
        title_subtasks: 'Sie haben das Limit für Teamübertragungen erreicht',
        title_scheduled: 'Die Planungsfunktion ist nur in Premium-Plänen verfügbar',
        title_speed: 'Fünffache Übertragungsgeschwindigkeit nur für Premium',
        title_sync: 'Sie haben das Limit für die normale Synchronisation erreicht',
        title_real: 'Sie haben das Limit für die Echtzeit-Synchronisierung erreicht',
        title_filter: 'Dateifilter ist exklusiv für Premium-Pläne',
        desc: 'Upgrade, um ALLE erweiterten Funktionen freizuschalten',
        itemTitle_th: 'Eigenschaften und Vorteile',
        itemTitle_traffic: 'Cloud-zu-Cloud-Datenverkehr',
        itemTitle_ins: 'Instagram-Profile zum Herunterladen',
        itemTitle_pdf: 'E-Mail in PDF umwandeln',
        itemTitle_modes: 'Synchronisierungsmodi',
        itemTitle_remote: 'Remote-Upload-Aufgaben parallel',
        itemTitle_subtasks: 'Unterkonten zwischen Teams migrieren',
        itemTitle_scheduled: 'Geplante Übertragung/Synchronisierung/Sicherung',
        itemTitle_speed: 'Übertragungsgeschwindigkeit',
        itemTitle_sync: 'Normale Synchronisierungsaufgaben parallel',
        itemTitle_real: 'Echtzeit-Synchronisierungsaufgaben parallel',
        itemTitle_filter: 'Dateifilter',
        itemTitle_tran: 'VIP-Übertragungsserver',
        itemTitle_customer: 'VIP-Kundensupport',
        itemTitle_watermark: 'Entfernen Sie Wasserzeichen aus PDF-E-Mails',
        itemValue_cur: 'Ihre aktuelle',
        itemValue_free: 'Kostenlos',
        itemValue_upgrade: 'Upgrade auf',
        itemvalue_premium: 'Premium',
        itemvalue_5gb: '5 GB / Monat',
        itemvalue_1profile: '1 Profil / Monat',
        itemvalue_50emails: '50 E-Mails / Monat',
        itemvalue_maxUnlimited: 'Maximal Unbegrenzt',
        itemvalue_unlimited: 'Unbegrenzt',
        button: 'Upgrade ab 9,99 €',
    },
     // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Ihr aktueller Plan',
        // 第1组
        gb5: '5 GB kostenloses Datenvolumen pro Monat',
        gb100: '100GB Datenvolumen pro Monat',
        gb200: '200GB Datenvolumen pro Monat',
        gb1200: '1200GB Datenvolumen pro Jahr',
        gb2400: '2400GB Datenvolumen pro Jahr',
        gbUnlimitedYear: 'Unbegrenztes Datenvolumen pro Jahr',
        gbUnlimitedLifetime: 'Unbegrenztes Datenvolumen für ein ganzes Leben',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 Ins-Profil zum Herunterladen pro Monat',
        ins10: '10 Ins-Profile zum Herunterladen pro Monat',
        ins20: '20 Ins-Profile zum Herunterladen pro Monat',
        ins120: '120 Ins-Profile zum Herunterladen pro Jahr',
        ins240: '240 Ins-Profile zum Herunterladen pro Jahr',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: '50 E-Mails pro Monat konvertieren',
        pdfUnlimited: 'unbegrenzte E-Mail-Konvertierungen',
        threads2: '2 Threads für Datenübertragung',
        threads10: '10 Threads für die Datenübertragung',
        scheduled: 'Geplante Übertragung/Synchronisation/Backup',
        // 第2组
        acrossClouds: 'Übertragung/Synchronisierung/Backup über Clouds hinweg',
        offline: 'Offline-Übertragung/Synchronisation/Backup',
        subAccounts3: '3 Unterkonten zwischen Teams',
        subAccounts1000: 'Migration von 1000 Unterkonten zwischen Teams',
        highSpeed: 'Hochgeschwindigkeits-Datenübertragung',
        // 第3组
        syncMode4: '4 Ein/Zwei-Wege-Synchronisationsmodi',
        syncMode10: '10 Ein/Zwei-Wege-Synchronisationsmodi',
        realSync: 'Echtzeit-Synchronisation',
        passwordProtected: 'Passwortgeschützte Freigabe',
        subAccounts: 'Unterkonten Zusammenarbeit',
        // 第4组
        cloud30: '30+ führende Cloud-Speicherdienste',
        unlimitedCloud: 'Unbegrenzt viele Cloud-Konten hinzufügen',
        singleLog: 'Einzige Anmeldung bei allen Wolken',
        support365: '24/7/365 vorrangiger Support',
        // 其他
        unlimitedDataTraffic: 'Unbegrenzter Cloud-zu-Cloud-Datenverkehr',
        unlimitedInsProfile: 'Unbegrenzte Downloads von Instagram-Profilen',
        unlimitedAllFeatures: 'Alle Premium-Funktionen',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'Sie haben den gesamten Datenverkehr verbraucht',
        vipPopupDescTraffic: 'Upgrade um unbegrenzten Datenverkehr freizuschalten',
        vipPopupTitleIns: 'Sie haben alle Downloads von Instagram-Profilen verbraucht',
        vipPopupDescIns: 'Upgrade um unbegrenzte Downloads von Instagram-Profilen freizuschalten',
    },
     //套餐arguments参数翻译
     arguments: {
         //参数名
         title: {
             monthly100GB: '100GB / Monat',
             monthly200GB: '200GB / Monat',
             monthlyUnlimit: 'Unbegrenzte Daten / Monat',
             yearly1200GB: '1200GB / Jahr',
             yearly2400GB: '2400GB / Jahr',
             yearlyUnlimit: 'Jährlich Unbegrenzt',
             lifetimeUnlimit: 'Lebenslang Unbegrenzt',
             package50GB: '50 GB',
             package100GB: '100 GB',
             giveAway500GB: '500GB / Jahr',
             giveAway200GB: '200GB / Jahr',
         },
         tips: {
             monthly100GB: 'z. B. Sie haben im ersten Monat nur 50 GB von 100 GB verbraucht und werden im nächsten Monat noch 50 GB zusätzliches Datenvolumen haben.',
             monthly200GB: 'z. B. Sie haben im ersten Monat nur 150 GB von 200 GB verbraucht und werden im nächsten Monat noch 50 GB zusätzliches Datenvolumen haben.',
             monthlyUnlimit: '',
             yearly1200GB: 'z. B. Sie haben im ersten Jahr nur 1000 GB von 1200 GB verbraucht und werden im nächsten Jahr noch 200 GB zusätzliches Datenvolumen haben.',
             yearly2400GB: 'z. B. Sie haben im ersten Jahr nur 2000 GB von 2400 GB verbraucht und werden im nächsten Jahr noch 400 GB zusätzliches Datenvolumen haben.',
             yearlyUnlimit: '',
             lifetimeUnlimit: '',
             package50GB: 'z. B. Wenn Sie in diesem Monat nur 20 GB von 50 GB verbraucht haben, bleiben die ungenutzten 30 GB auch im nächsten Monat erhalten.',
             package100GB: 'z. B. Wenn Sie in diesem Monat nur 20 GB von 100 GB verbraucht haben, bleiben die ungenutzten 80 GB auch im nächsten Monat erhalten.',
         }
     },
 },
     //双重验证功能
     twoStepverification:{
         bind:'E-Mail zuerst binden',
         addVerify:'Sie müssen eine Methode zur Bestätigung hinzufügen.',
         phoneNotEmpty:'Die Telefonnummer darf nicht leer sein.',
         addPhone:'Telefonnummer hinzufügen',
         addAlEmail:'Alternative E-Mail-Adresse hinzufügen',
         verifySet:'Bestätigungseinstellung',
         addWayVerify:'Bestätigungsmethode hinzufügen',
         enterEmail:'Ihre E-Mail eingeben',
         enterPhone:'Ihre Telefonnummer eingeben',
         enterCode:'Bitte geben Sie den Code ein, an den wir gesendet haben',
         enterCodeTip:'Bitte überprüfen Sie Ihren Junk-Mail-Ordner und melden Sie ihn nicht als Spam oder fügen Sie "no-reply@multcloud.email" zu Ihrer Whitelist hinzu.',
         codeExpired:'Der Bestätigungscode ist abgelaufen.',
         codeinCorrect:'Der Bestätigungscode ist falsch. Bitte überprüfen Sie den Code und versuchen Sie es erneut.',
         verificationTurnOn:'Die zweistufige Bestätigung ist aktiviert.',
         recoverAccess:'Dieser Code wird Ihnen helfen, wenn Sie den Zugang zu Ihrem Konto wiederherstellen müssen. Sie sollten sie aufschreiben und an einem sicheren Ort aufbewahren. Wir empfehlen Ihnen dringend, den Wiederherstellungscode nicht auf Ihrem Gerät zu speichern.',
         longValid:'Wenn Sie zuvor einen Wiederherstellungscode hatten, ist dieser nicht mehr gültig.Verwenden Sie stattdessen diesen neuen Code.',
         removeAll:'Alle Geräte entfernen?',
         lostAccess:'Wir empfehlen Ihnen, dies zu tun, wenn Sie den Zugriff auf ein vertrauenswürdiges Gerät verloren haben.',
         removeMethod:'Entfernen Sie die Bestätigungsmethode?',
         removeMethodSure:'Möchten Sie diese Bestätigungsmethode wirklich entfernen? Wenn Sie sie entfernen, können Sie sie nicht zur Bestätigung verwenden.',
         getRecode:'Wiederherstellungscode erhalten',
         emailCode:'Code per E-Mail senden',
         TextCode:'Code per SMS senden',
         useAccount:'Sie verwenden jetzt ein temporäres Konto.Bitte binden Sie die E-Mail und versuchen Sie es erneut.',
         removeTrusted:'Alle vertrauenswürdigen Geräte entfernen',
         finish:'Fertig',
         newCode:'Dein neuer Code ist',
         twoStep:'Bestätigung in zwei Schritten',
         twoStepis:'Zwei-Schritt-Verifizierung ist',
         on:'Ein',
         off:'Aus',
         cancel:'Stornieren',
         toManyCodeSend:'Zu viele Codes gesendet',
         verifyIdenti:'Identität bestätigen mit',
         codeCopied:'Code kopiert!',
         copyCode:'Code kopieren',
         trustedDevice:'Vertrauenswürdige Geräte entfernt!',
         phoneValueTips:'Tipps: Bitte entfernen Sie die führende Null und alle Leerzeichen, Bindestriche oder Klammern.',
     },
     website: {
        cloneNow: 'Jetzt klonen',
        addTaskNow: 'Aufgabe hinzufügen und jetzt klonen',
        siteFromTitle: 'WEBSITE ZUR SICHERUNG',
        siteFromDesc: 'Klicken Sie hier, um die Quell-Website-Daten auszuwählen, die Sie sichern möchten',
        siteToTitle: 'WO DIE SICHERUNG GESPEICHERT WIRD',
        siteToDesc: 'Klicken Sie hier, um das Cloud-Laufwerk oder den Ordner auszuwählen, in den übertragen werden soll',
        sourceServers: 'Quellserver',
        targetServers: 'Zielserver',
        desc: 'Sichern Sie Ihre Website-Dateien und Datenbank in der Cloud oder migrieren Sie Ihre Website auf einen neuen Host oder eine neue Domain.',
        addSite: 'Website-Dateien hinzufügen',
        addSiteMore: 'Weitere Website-Dateien hinzufügen',
        removeSite: 'Website-Dateien entfernen',
        addDb: 'Datenbank hinzufügen',
        addDbMore: 'Weitere Website-Datenbanken hinzufügen',
        removeDb: 'Website-Datenbank entfernen',
        cloneSameNodeWarning: 'Quelle und Ziel des Klons dürfen nicht derselbe Knoten sein.',
        cloneTypeMismatchWarning: 'Quell- und Zieltyp des Klons stimmen nicht überein.',
        clonePairExistsWarning: 'Dieselbe Kombination aus Quelle und Ziel ist bereits vorhanden.',
        taskNameRequired: 'Bitte geben Sie einen Aufgabennamen ein',
        switchToPlusForWebsiteTasks: 'Um Website-Backup-Aufgaben anzuzeigen, müssen Sie zu MultCloud Plus wechseln.',
        title: 'Website-Backup und -Klonung',
},
     cloudBackup:{
         cloudBackup:'Cloud Backup',
         setUpCloud:'Einrichten eines Cloud-Backup-Auftrags zum Sichern von Online-Dateien von einer Cloud in eine andere',
         filesBckupTarget: 'Ziel-Verzeichnisse',
         filesBckup:'Zu sichernde Dateien',
         selectSoure:'Klicken Sie hier, um die Quell-Cloud-Dateien auszuwählen, die Sie sichern möchten',
         saveBackup:'Sicherungsort',
         selectTarget:'Klicken Sie hier, um die Ziel-Cloud zu speichern, um das Backup zu speichern',
         backupNow:'Jetzt sichern',
         canSelect:'Sie k?nnen maximal 10000 Artikel auswählen',
         backupFiles:'Sie k?nnen Ihre Dateien nicht in Google Fotos sichern.',
         notSelectEvernoteBackup: 'Sie k?nnen Ihre Dateien nicht in Evernote sichern.',
         backFlickr:'Sie k?nnen Ihre Dateien nicht auf Flickr sichern.',
         thankSubscrib:'Vielen Dank, dass Sie unseren Dienst abonniert haben. Sie können jetzt maximal 10 Dateien gleichzeitig sichern.',
         maximunBack:'Sie haben jetzt maximal 2 Dateien gleichzeitig gesichert. Upgraden Sie auf einen beliebigen Premium-Dienst, um maximal 10 zu haben! ',
         backSuccess:'Erfolg sichern',
         backFailure:'Fehler sichern',
         successBck:'Erfolgreiches Sichern aller Dateien',
         taskCanceled:'Die Aufgabe wurde manuell abgebrochen',
         notRestore:'Ich kann die Dateien zum Wiederherstellen nicht finden. M?glicherweise sind sie bereits gel?scht worden.',
         selectVersions:'Versionen auswählen',
         restoreOptions:'Optionen wiederherstellen',
         selectFiles:'W?hlen Sie die Dateien, die Sie wiederherstellen m?chten.',
         toRestore:'Bitte w?hlen Sie eine Datei zum Wiederherstellen aus.',
         originalLocation:'Ursprünglicher Standort',
         thankRestore:'Vielen Dank, dass Sie unseren Service abonniert haben. Sie können jetzt maximal 10 Dateien gleichzeitig wiederherstellen.',
         restoreSimult:'Sie k?nnen jetzt maximal 2 Dateien gleichzeitig wiederherstellen. Upgraden Sie auf einen beliebigen Premium-Dienst, um maximal 10 zu haben!',
         restoreSuccess:'Erfolg wiederherstellen',
         restorePartial:'Teilerfolg wiederherstellen',
         restoreFailure:'Fehler wiederherstellen',
         notRestore:'Ich kann die Dateien zum Wiederherstellen nicht finden. M?glicherweise sind sie bereits gel?scht worden.',
         backupTime:'Backup-Zeit',
         changedFiles:'Geänderte Dateien',
         deleteVersion:'M?chten Sie die Backup-Version wirklich l?schen?',
         deleteFiles:'Die Dateien in dieser Version l?schen',
         keepLatest:'Immer die aktuellste Datei behalten',
         overWriteFile:'Datei überschreiben',
         skipFile:'Datei überspringen',
         versions:'Versionen',
         backupTask:'Backup-Aufgabe',
         readdCloud:'Cloud erneut hinzufügen',
         selectedCloud:'Einige der ausgewählten Clouds wurden zu MultCloud hinzugefügt, bevor Cloud Backup veröffentlicht wurde. Wir empfehlen, die Clouds erneut zu MultCloud hinzuzufügen und es erneut zu versuchen.',
         continueAnyway:'Fortsetzen Jedenfalls',
         selectedHasAdded:'Die ausgewhlte Cloud wurde zu MultCloud hinzugefügt, bevor Cloud Backup veröffentlicht wurde. Wir empfehlen, die Cloud erneut zu MultCloud hinzuzufügen und es erneut zu versuchen.',
         failCreate:'Backup-Aufgabe konnte nicht erstellt werden.',
         failLoad:'Laden fehlgeschlagen',
         pleaseReAdd:'fügen Sie bitte die Wolken erneut zu MultCloud hinzu.',
         alreadyAdd:'Sie haben das Cloud-Laufwerk bereits hinzugefügt.',
         failRename:'Umbenennung fehlgeschlagen, da der entsprechende Ordner nicht gefunden werden kann.',
         taskRuning:'Die Aufgabe läuft, bitte warten Sie, bis die Aufgabe beendet ist und versuchen Sie es erneut.',
          //2021-08-07添加
         oneBackup:'Sie können nur eine Sicherungs- oder Wiederherstellungsaufgabe gleichzeitig ausführen',
         restoreTask:'Wiederherstellungsaufgabe',
         restoreOriginal:'Am ursprünglichen Speicherort wiederherstellen',
         restoreNewLocation:'An einem neuen Speicherort wiederherstellen',
         backingUp:'Sichern',
         restoring:'Wiederherstellen',
         restore:'Wiederherstellen',
         backup:'Sicherung',
          //2021-08-17添加
         maxNum:'Die maximale Anzahl von Quellartikeln beträgt 1000. Bitte wählen Sie weniger Artikel aus. P.S. Ein ganzer Ordner zählt nur ein Element.',
         maxLogs:'Hinweis: Das Ergebnis ist abgeschnitten. Hier werden bis zu 1.000 fehlgeschlagene Dateien angezeigt.',
         backupDetails:'Sicherungsdetails',
         keepTwoFile:'Zwei Dateien behalten',
         restoreDetails:'Details wiederherstellen',
         longerDelete:'Es kann länger dauern, wenn eine große Anzahl von Dateien zu löschen ist.',
         notFoundAim:'Das Zielverzeichnis kann nicht gefunden werden.',
           //2021-10-20
         backupNotWork:'Der Sicherungsdienst funktioniert nicht',
          //2021-10-28
         backupPartial:'Teilweiser Backup-Erfolg',
         configFile:'(Hochladen der Konfigurationsdatei)',
         successRestore:'Erfolgreiche Wiederherstellung aller Dateien.',
         notFind:'Die Konfigurationsdatei kann nicht gefunden werden. Bitte prüfen Sie, ob die Konfigurationsdatei existiert und die Verbindung zwischen dem Cloud-Laufwerk und MultCloud gültig ist.',
         selectRestoreItems:'Bitte wählen Sie die Dateien aus, die Sie wiederherstellen möchten.',
         selectRestoreTotles:'Bitte wählen Sie ein Verzeichnis zur Wiederherstellung aus.',
         original: 'Original',
         inTotalTip: '{count} Dateien, insgesamt {size}',
         backupPathConflict: 'Der Zielordner darf nicht mit der Quelle identisch sein, darf sich nicht innerhalb der Quelle befinden und darf nicht der Ordner sein, der die Quelle enthält. Bitte wählen Sie ein anderes Ziel.',
     },
     affiliateProgram: {
         leftTitle: "Unser Partner werden",
         title: "MultCloud-Partnerprogramm",
         headTips1: "Verdienen Sie bis zu <span>50%</span> Provision.",
         headTips2: "Anmelden mit ein paar Klicks, völlig <span>kostenlos</span>.",
         headTips3: "Keine zusätzlichen Bedingungen, <span>jeder</span> kann unser Partner werden!",
         signUpBtn: "Partnerkonto anmelden",
         tips: "Tipps: Wenn Sie bereits ein Partner bei Cleverbridge sind, <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> melden Sie sich bitte an</a>.",
         howDoTipsTitle: "Wie funktioniert das?",
         howDoTipsMsg: "Sobald Sie sich in unserem Partnerprogramm angemeldet und eingeloggt haben, finden Sie AOMEI International Network Limited unter dem Schild „Kampagnen - Kampagne beitreten”. Klicken Sie darauf und bestätigen Sie den Beitritt. Sobald Sie unserer Kampagne beigetreten sind, werden Sie alle verfügbaren MultCloud-Produkte sehen. Wenn jemand MultCloud über Ihren Empfehlungslink upgraden, werden Sie mit <span>30%-50%</span> Provisionssatz bezahlt.",
         FAQsTitle: "FAQs zum MultCloud-Partnerprogramm",
         FAQ1: "Wie funktioniert das Partnerprogramm?",
         answer1: "Sobald Ihr Kunde über Ihre Empfehlungsseite bezahlt hat, erhalten Sie Ihre Auszahlung am Anfang des nächsten Monats.",
         FAQ2: "Das klingt großartig. Wie kann ich mich anmelden?",
         answer2: "Sie können sich anmelden, indem Sie oben auf \„Partnerkonto anmelden\” klicken. In nur wenigen Schritten haben Sie Ihr Partnerkonto.",
         answerPs2: "Tipps: Sobald Sie sich in der Konsole angemeldet haben, finden Sie AOMEI International Network Limited unter der Registerkarte \„Kampagnen\”. Klicken Sie darauf und bestätigen Sie den Beitritt.",
         FAQ3: "Wie viel Provision bekomme ich?",
         answer3: "Die Provision unterscheidet sich je nach Abonnementplan. Zum Beispiel beträgt der Provisionssatz für den monatlichen Plan 30 %, aber für den lebenslangen unbegrenzten Plan beträgt er 50 %.",
         FAQ4: "Wie werde ich bezahlt?",
         answer4: "Das hängt von der „Zahlungsmethode” ab, die Sie angegeben haben. Sie werden immer am Anfang eines jeden Monats bezahlt.",
         answerPs4: "Tipps: Für jede Auszahlung gibt es keinen Mindestbetrag.",
         anyQuestionTitle: "Haben Sie eine Frage?",
         anyQuestionTip: "Bitte wenden Sie sich an: <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
     },
     signUp: {
         pwdTip: "Passwort (8-16 Zeichen)",
         signingUp: "Anmeldung . . .",
         tips2: "Mit der Erstellung eines Kontos akzeptieren Sie die  <a href=\"https://www.multcloud.com/de/terms\" class=\"alink\">Nutzungsbedingungen <a/>&nbsp;und&nbsp;<a href=\"https://www.multcloud.com/de/policy\" class=\"alink\"> Datenschutz-Bestimmungen<a/>.",
         emailPushTip: "Durch Auswahl dieser Option, erklären Sie sich damit einverstanden, E-Mails von MultCloud über Produkt- und Service-Aktualisierungen, Sonderangebote und Veranstaltungen zu erhalten. Sie können sich jederzeit wieder abmelden.",
     },
     forgetPwd: {
         title: "Passwort vergessen?",
         tip: "Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
         sending: "Senden der Nachricht ...",
         btnTxt: "Reset-E-Mail senden",
         tips1: "E-Mail Adresse vergessen?",
         tips2: "Senden Sie eine E-Mail an den Support",
         tips3: "und werden wir sie aufspüren.",
     },
     balackFriday: {
         lastTip: "ENDET BALD! BEVOR DAS ANGEBOT WEG IST!",
         title: "Frühzeitiger Zugang zum Black Friday und Cyber Monday, um UNBEGRENZTEN Cloud-zu-Cloud Datenvolumen mit 70% OFF Verkauf zu erhalten!",
        titleTip: "Beeilen Sie sich, solange der Vorrat reicht!",
     },
     christmas: {
        payTxt: "Weihnachtsverkauf",
        popupTitle: "MULTCLOUD-SUPERVERKAUF",
        pageTitle: "Holen Sie sich UNBEGRENZTEN Cloud-to-Cloud-Datentrafiic auf Lebenszeit mit {num}% Rabatt!",
        pageTitle2: "Erhalten Sie UNBEGRENZTEN Datenvolumen auf Lebenszeit mit {num}% Rabatt!",
        paysysTitle: "BEEILEN SIE SICH, BEVOR ES WEG IST!",
        popupTip1: "UNBEGRENZTER Cloud-zu-Cloud-Datenvolumen",
        popupTip2: "10 Hochgeschwindigkeits-Datenübertragungsthreads",
        popupTip2Append: "Es gibt 10 Übertragungsthreads für Premium-Nutzer und 2 Übertragungsthreads für kostenlose Nutzer",
        popupTip3: "Geplante Übertragung/Sync/Backup",
        popupTip4: "Ein-Wege/Zwei-Wege-Echtzeitsync",
        popupTip4Append: "Es gibt 7 zusätzliche Sync-Modi für Premium-Benutzer. Spiegel-Synchronisation unterstützt",
        saledBtn: "JETZT EINKAUFEN",
     },
     teamTransfer:{
         teamTransfer:'Team-Übertragung',
         transferMultiple:'Übertragung mehrerer Konten von einer Cloud-Plattform auf eine andere (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
         businessCloud:'Wenn Sie ein Administrator von Business-Clouds sind, können Sie diese Funktion nutzen, um alle Konten von einer Business-Cloud zur anderen zu migrieren. Zum Beispiel wird jeder Benutzer einen eigenen Ordner in einer Cloud-Plattform haben. MultCloud kann automatisch die Ordner von zwei verschiedenen Business-Clouds zusammenführen und die Dateien von einer Cloud zur anderen migrieren.',
         clickSelect:'Klicken Sie hier, um die Cloud-Services auszuwählen, von denen Sie die Daten übertragen möchten.',
         sourceAccount:'Quellkonten',
         targetAccounts:'Zielkonten',
         autoMatch:'Auto-Match',
         likeTransfer:'Klicken Sie hier, um die Cloud-Dienste für Ihr Unternehmen auszuwählen, auf die Sie übertragen möchten.',
         youMust:'Sie müssen zunächst einen',
         cloudService:' Business Cloud Service ',
         asAdmin:' als Administrator hinzufügen.',
         combinations:'Auto-Match wird die aktuellen Kombinationen bereinigen. Sind Sie sicher, dass Sie fortfahren möchten?',
         nosourceAccount:'Es gibt weder ein Quellkonto noch ein Zielkonto.',
         noAccount:'Es gibt keine Konten für Auto-Match.',
         uploadCSV:'CSV hochladen',
         cleanCurrent :'CSV hochladen wird die aktuellen Kombinationen bereinigen. Sind Sie sicher, dass Sie fortfahren möchten?',
         csvFile:'Die von Ihnen hochgeladene CSV-Datei muss dem ',
         csvFormat:'CSV-Format entsprechen.',
         matchCsv:'Die Organisation kann keine Kombination aus der CSV-Datei zuordnen. Bitte überprüfen Sie die CSV-Datei und versuchen Sie es erneut.',
         alreadyAdd:'Sie haben bereits die Kombination dieser beiden Konten hinzugefügt.',
         cleanAll:'Sie sind dabei, alle ausgewählten Kombinationen zu löschen. Sind Sie sicher, dass Sie fortfahren wollen?',
         sure:'Ja, ich bin sicher',
         allTransferred:'Bewahren Sie alle übertragenen Dateien in einem Ordner auf.',
         optionActivated:'Wenn diese Option aktiviert ist, werden alle übertragenen Dateien in einem Ordner der Zielwolke gespeichert. Wenn beispielsweise das Quellverzeichnis Google Workspace\\simon@multcloud.com und das Zielverzeichnis OneDrive for Business\\peter@multcloud.com ist, werden alle Dateien in Google Workspace\\simon@multcloud.com zu OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com übertragen, wenn diese Option aktiviert ist.',
         organizationMigration:'Organisation Migration',
          //jimin新增
         downloadCSV:'CSV herunterladen',
         dontShow:'Nicht mehr anzeigen',
         notSelected:'Das freigegebene Google Workspace-Laufwerk kann nicht als Ziel-Cloud für die Team-Migration ausgewählt werden.',
         batchMatch:'Stapelabgleich',
         sourceCloud:'QuellCloud hinzufügen',
         targetCloud:'ZielCloud hinzufügen',
         subTaskLimit:'Teilaufgaben-Limit',
         freeUsers:'Kostenlose Benutzer können 3 Paare von Unteraufgaben in einer Team-Übertragung-Aufgabe erstellen, bitte aktualisieren Sie auf die Premium-Version und Sie können 1000 Unteraufgaben in einer Team-Übertragung-Aufgabe haben.',
         mostTeamTransfer:'3 Teilaufgaben in einer Team-Übertragung',
         substasksMost:'1000 Teilaufgaben in einer Team-Übertragung',
         mostTasks:'Die Anzahl der Teilaufgaben kann maximal 1000 betragen.',
         timePassed:'Die eingestellte Zeit ist abgelaufen.',
     },
 shareTransfers: {
     logoMsg: '<span class="sf-logo-first">MultCloud-</span><span class="sf-logo-name">Übertragung</span>',
     addFiles: 'Dateien aus Clouds hinzufügen',
     trnsfering: 'Übertragen ...',
     sendingFile: 'Senden von {num} Datei(en)',
     sendingSize: '{num} von {all}',
     sendingTip: 'Übertragungslink wird erstellt, bitte warten.',
     cancelTransfer: 'Diese Überweisung abbrechen?',
     createdTransfer: 'Übertragung erstellt!',
     createShare: 'Übertragung erstellen',
     signTitleByTransfer: 'Zum Fortfahren bei Multcloud anmelden',
     signupTitleByTransfer: 'Melden Sie sich in Multcloud an, um fortzufahren',
     transferTitle: 'Titel',
     transferDescription: 'Beschreibung',
     addFileTip: '{num} Datei(en) hinzugefügt',
     titleErrMsg: 'Der Titel sollte nicht mehr als 128 Zeichen lang sein.',
     desErrMsg: 'Die Beschreibung sollte nicht länger als 512 Zeichen sein.',
     folder: 'Ordner',
 },
 summerSale: {
    titleTip: 'Hallo Sommer',
    titleTip2: 'Erhalten Sie UNBEGRENZTEN Cloud-zu-Cloud-Datenverkehr und verwalten mühelos alle Ihre Sommererinnerungen zu einem attraktiven Preis!',
    bottomTip: '- DAS BESTE ANGEBOT DER SAISON -',
 },
 halloweenSale: {
    titleTip2: 'Sparen Sie bis zu 70% bei Keine Tricks, verwöhnen Sie sich selbst mit Unbegrenztem Cloud-zu-Cloud-Datenvolumen! ',
    bottomTip: 'Beeilen Sie sich! Bevor es weg ist.',
},
newYear: {
    payTxt: "NEUJAHRSVERKAUF",
    titleTip: "Begrüßen Sie das neue Jahr mit 70% Rabatt auf UNBEGRENZTEN Cloud-zu-Cloud-Datenverkehr!",
    bottomTip: 'Beeilen Sie sich! Bevor es weg ist.',
},
backToSchool: {
    titleTip2: 'Erhalten Sie UNBEGRENZTEN Cloud-zu-Cloud-Datenverkehr und verwalten alle Ihre Schulerinnerungen zu einem tollen Preis!',
    bottomTip: '- DAS BESTE ANGEBOT DER SAISON -',
 },
blackFriday: {
    titleTip: 'Erhalten Sie 70 % Rabatt auf UNBEGRENZTEN Cloud-zu-Cloud-Datenverkehr.',
    bottomTip: 'Beeilen Sie sich! Bevor es weg ist.',
},
xmas: {
    titleTip: 'Genießen Sie zu Weihnachten einen festlichen Rabatt von 70% auf UNBEGRENZTEN Cloud-zu-Cloud-Datenverkehr!',
    bottomTip: 'Beeilen Sie sich! Bevor es weg ist.',
},
license: {
    codeTitle: 'Lizenz eingeben',
    codeTipTitle: 'Lizenzcode eingeben',
    codeTipText: 'Wenn Sie einen Lizenzcode haben, können Sie ihn zur Aktivierung des Premium-Dienstes verwenden.',
    codeTipTextVip: 'Wenn Sie einen Lizenzcode haben, können Sie ihn nutzen, um auf einen erweiterten Dienst upzugraden.',
    codeFooter: 'Bei Fragen wenden Sie sich bitte an: ',
    showTitle: 'Lizenzcode',
    showTip: 'Der Lizenzcode lautet:',
    codeSucTitle: 'Premium-Dienst aktiviert',
    codeSucTip: 'Premium-Dienst aktiviert!',
},
filters: {
    taskList: {
        typeName: 'Typ',
        type: {
            all: 'Alle Listen',
            copy: 'Temporäre Aufgabe',
            transfer: 'Cloud-Übertragung',
            sync: 'Cloud-Synchronisation',
            backup: 'Cloud-Backup',
            business: 'Team-Übertragung',
            remoteUpload: 'Remote-Upload',
            emailMigration: 'E-Mail-Migration',
            restore: 'Cloud-Wiederherstellung',
        },
        statusName: "Status",
        status: {
            all: "Alle Status",
            preset: 'Voreinstellung',
            running: 'Wird ausgeführt',
            success: 'Erfolgreich',
            patial: 'Teilweise erfolgreich',
            failed: 'Fehlgeschlagen',
            canceled: 'Abgebrochen',
        },
        dateName: "Datum",
        date: {
            all: 'Gesamter Zeitraum',
            today: 'Heute',
            latestWeek: 'Letzte Woche',
            latestMonth: 'Letzter Monat',
            customDate: 'Benutzerdefiniertes Datum',
        },
    }
},
schedule: {
    week1: "So",
    week2: "Mo",
    week3: "Di",
    week4: "Mi",
    week5: "Do",
    week6: "Fr",
    week7: "Sa",
},
inputTab: {
    filterMessage: 'Dateierweiterung mit Enter-Taste hinzufügen',
}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/deutsch.js